import React, {useEffect, useRef, useState} from 'react';
import './ProductDetailsNew.css';
import './ProductDetailsNewJack.css';
import "./Textura.css";
import { Modal } from 'antd';
import {
    Col, Row, Layout, Collapse, Image, Space, Carousel,
} from 'antd';
import {Content} from "antd/es/layout/layout";
import {HOME_TEXT, PRODUCT_TEXT} from "../../text"
import {ProductDetailPageMeta} from "../../components/PageMeta/ProductDetailPageMeta";

import {TEXTURA_TEXT} from "../../text";
import install1 from "./logos/demo1.png"
import install2 from "./logos/digital-install2.png"
import klarma_icon from "./logos/payments.png"
import KlarnaImg from './logos/KlarmaBigImage.png'
import {MinusOutlined, PlusOutlined, StarFilled} from "@ant-design/icons";
import {Reviews, ReviewCard} from "./Reviews";
import VerticalCarousel from "../../components/Carousel/VerticalCarousel";
import {ReactComponent as RadarLogo} from "./logos/techradar-logo 1.svg"
import {ReactComponent as IndeLogo} from './logos/inde.svg'
import useWindowResize from "../../apps/Hooks/useWindowResize";
import {useMediaQuery} from "react-responsive";
import {useLocation, useSearchParams} from "react-router-dom";
import frame1 from './imgs/Birch empty.png'
import frame2 from './imgs/White empty.png'
import frame3 from './imgs/Walnut empty.png'
import frame4 from './imgs/Black empty.png'
const Transforming_Img = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/2+-+Discover+the+World/Vieunite_Mockup_03_2.jpeg";
const Vieunite_App_Vd2 = "https://d1mluz1pfkw29o.cloudfront.net/img/HomePage/7+-+Vieunite+App/phone2.webm";
const MadeForYou_Img = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/4+-+Made+For+You/frame_example.png";
const mLifeLike_Img = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/3+-+Textura/Pine-mobile-tablet.webp";
const LifeLike_Img = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/3+-+Textura/Pine-desktop.png";
const leftScroll = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/5+-+Textura+App/LeftScroll.png";
const rightScroll = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/5+-+Textura+App/RightScroll.png";
const YouTubeLogo = "https://d1mluz1pfkw29o.cloudfront.net/img/Textura/5+-+Textura+App/youtube_logo.png";
// Fake cards for testing
// Payment succeeds
// 4242 4242 4242 4242
// Payment requires authentication
// 4000 0025 0000 3155
// Payment is declined
// 4000 0000 0000 9995
const {Panel} = Collapse;

const PRICE = 599;
const maxLimitTop = '1250px'

const COLOR_CODE = {
    'a': 'Black', 'b': 'White', 'c': 'Pine', 'd': 'Walnut',
}

const PrimaryFont = {
    fontFamily: "Proxima Nova bold, sans-serif",
}

const MWidth = {
    span: 20,
}

const TitleFont = {
    fontWeight: '700', fontSize: '2rem', fontFamily: "Proxima Nova bold, sans-serif"
}

function scrollDown(id) {
    window.location = id;
    window.scrollBy(0, -100);
}

const makeMuted = (elt) => {
    if (elt) {
        elt.muted = true;
    }
};

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ProductDetailsNewJack = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const paymentStatus = searchParams.get('successful_payment');
        if (paymentStatus === 'True' || paymentStatus=== 'true') {
            localStorage.clear()
            Modal.success({
                title: 'Payment Successful!',
                content: 'Thank you for your purchase. Your payment was successful.',
                // Customize the OK button by providing the okText property
                okText: 'Continue Shopping',
                okButtonProps: {
                    // You can add any inline styles or a custom class here
                    style: {
                        backgroundColor: 'black',
                        color: 'white',
                        border: 'none',
                        fontSize: '16px',
                        fontWeight: '600',
                    },
                    className: 'custom-ok-button', // optional: add a custom class name to target in your CSS
                },
                onOk: () => {
                    // Optionally remove the query parameter after acknowledgment
                    window.history.replaceState({}, document.title, window.location.pathname);
                    window.location.reload()
                },
            });
        }
    }, [searchParams]);
    const [installDemo, setInstallDemo] = useState(install1);
    const [color, setColor] = useState('a');
    const [index, setIndex] = useState(0);
    const [activeLineIndex, setActiveLineIndex] = useState(0);
    const sliderRef = useRef(null);
    const query = useQuery();
    const promocode = query.get('promocode');
    console.log(promocode)

    const {windowWidth} = useWindowResize()

    const totalLines = windowWidth >= 920 ? 6 : 8; // 固定显示4个横线
    const ScrollInactive = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="4" viewBox="0 0 30 4" fill="none">
            <path d="M2 2H28" stroke="#D9D9D9" stroke-width="3" stroke-linecap="round"/>
        </svg>);

    const ScrollActive = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="4" viewBox="0 0 30 4" fill="none">
            <path d="M2 2H28" stroke="#717171" strokeWidth="3" strokeLinecap="round"/>
        </svg>);

    const slideRight = () => {
        const newIndex = (index + 1) % totalLines;
        setIndex(newIndex);
        setActiveLineIndex(prevLineIndex => (prevLineIndex + 1) % totalLines);
    };

    const slideLeft = () => {
        const newIndex = (index - 1 + totalLines) % totalLines;
        setIndex(newIndex);
        setActiveLineIndex(prevLineIndex => (prevLineIndex - 1 + totalLines) % totalLines);
    };

    const checkOut = () => {
        // const color = this.state.color;
        //a:black,b:white,c:pine,d:walnut
        if (color === 'a') {
            // window.open(`https://buy.stripe.com/fZe7sO2SufPpejK28e?${promocode ? `prefilled_promo_code=${promocode}` : ''}`, '_blank');
            const currentValue = parseInt(localStorage.getItem('black') || '0', 10);
            localStorage.setItem('black', (currentValue + 1).toString());
            localStorage.setItem('openCart','1')
            window.location.reload()
            // Modal.success({
            //     title: 'Success!',
            //     content: 'The canvas was added to cart.',
            //     onOk: () => window.location.reload(),
            //     // okButtonProps: {
            //     //     style: { backgroundColor: '#52c41a', border: 'none' },
            //     //     // You can add other button props here
            //     // },
            // });
        } else if (color === 'b') {
            // window.open(`https://buy.stripe.com/3csfZk2Su5aLcbC9AK?${promocode ? `prefilled_promo_code=${promocode}` : ''}`, '_blank');
            const currentValue = parseInt(localStorage.getItem('white') || '0', 10);
            localStorage.setItem('white', (currentValue + 1).toString());
            localStorage.setItem('openCart','1')
            window.location.reload()
            // Modal.success({
            //     title: 'Success!',
            //     content: 'The canvas was added to cart.',
            //     onOk: () => window.location.reload(),
            // });
        } else if (color === 'c') {
            // window.open(`https://buy.stripe.com/fZecN8gJkcDda3u5kt?${promocode ? `prefilled_promo_code=${promocode}` : ''}`, '_blank');
            const currentValue = parseInt(localStorage.getItem('pine') || '0', 10);
            localStorage.setItem('pine', (currentValue + 1).toString());
            localStorage.setItem('openCart','1')
            window.location.reload()
            // Modal.success({
            //     title: 'Success!',
            //     content: 'The canvas was added to cart.',
            //     onOk: () => window.location.reload(),
            // });
        } else if (color === 'd') {
            // window.open(`https://buy.stripe.com/eVa28uct48mX5NefZ5?${promocode ? `prefilled_promo_code=${promocode}` : ''}`, '_blank');
            const currentValue = parseInt(localStorage.getItem('walnut') || '0', 10);
            localStorage.setItem('walnut', (currentValue + 1).toString());
            localStorage.setItem('openCart','1')
            window.location.reload()
            // Modal.success({
            //     title: 'Success!',
            //     content: 'The canvas was added to cart.',
            //     onOk: () => window.location.reload(),
            // });
        } else {
        }
    };
    const handleDragStart = (e) => {
        if (e.type === 'touchstart') {
            sliderRef.current.startX = e.touches[0].clientX;
        } else {
            sliderRef.current.startX = e.clientX;
        }
    };

    const handleDragMove = (e) => {
        if (!sliderRef.current.startX) return;

        let currentX;
        if (e.type === 'touchmove') {
            currentX = e.touches[0].clientX;
        } else {
            currentX = e.clientX;
        }

        const diff = sliderRef.current.startX - currentX;
        if (diff > 50) {
            // Swipe left
            slideRight();
            sliderRef.current.startX = null;
        } else if (diff < -50) {
            // Swipe right
            slideLeft();
            sliderRef.current.startX = null;
        }
    };

    const handleDragEnd = () => {
        sliderRef.current.startX = null;
    };

    const [activeIndex, setActiveIndex] = useState(0); // Track the active column index
    const totalCols = 4; // Assuming you have 4 columns in .magic-switching-yang
    const intervalRef = useRef(null);

    // Auto switch every 3 seconds
    // useEffect(() => {
    //     intervalRef.current = setInterval(() => {
    //         setActiveIndex((prevIndex) => (prevIndex + 1) % totalCols);
    //     }, 3000); // Change every 3 seconds
    //
    //     // Clean up the interval when component unmounts
    //     return () => {
    //         clearInterval(intervalRef.current);
    //     };
    // }, []);
    // Step 1: Calculate the last day of the current month
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    const lastDayDate = new Date(year, month + 1, 0);

    // Step 2: Format the date
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const monthName = monthNames[lastDayDate.getMonth()];

    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return day + 'th'; // For 11th to 20th
        switch (day % 10) {
            case 1:
                return day + 'st';
            case 2:
                return day + 'nd';
            case 3:
                return day + 'rd';
            default:
                return day + 'th';
        }
    }

    const dayWithSuffix = getOrdinalSuffix(lastDayDate.getDate());
    const yearNumber = lastDayDate.getFullYear();
    const formattedDate = `${monthName} ${dayWithSuffix} ${yearNumber}`;

    const isMobile = useMediaQuery({query: '(max-width: 992px)'});

    return (<div>
        <ProductDetailPageMeta></ProductDetailPageMeta>
        <Layout style={{marginTop: '35px'}}>
            <Content style={{background: "#f4f4f4"}}>

                <Carousel
                    dots={true}
                    dotPosition={"bottom"}
                    autoplay={true}
                    autoplaySpeed={2000}
                    style={{paddingTop: '80px', display: isMobile ? 'block' : 'none'}}
                >
                    <div>
                        <div className={'pd-new-top-col-mobile'}>
                            <svg
                                style={{marginRight: '10vw'}}
                                xmlns="http://www.w3.org/2000/svg" width="49" height="29"
                                viewBox="0 0 49 29"
                                fill="none">
                                <g clip-path="url(#clip0_4_1401)">
                                    <path
                                        d="M0 11.2945C0.382543 10.4668 1.03737 10.2146 1.92805 10.228C4.62215 10.2664 7.31817 10.2462 10.0132 10.2395C10.9931 10.2366 11.646 9.4934 11.5137 8.56219C11.413 7.85251 10.9576 7.47849 10.1264 7.47177C8.73904 7.45931 7.35173 7.46698 5.96441 7.46698C4.97593 7.46698 3.98746 7.47082 2.99802 7.46602C2.07762 7.46123 1.42854 6.85416 1.43717 6.01693C1.44484 5.19984 2.08721 4.60524 2.97885 4.59661C3.50137 4.59182 4.02293 4.59661 4.59339 4.59661C4.59339 3.55223 4.5886 2.55197 4.59435 1.5517C4.6001 0.591719 5.18974 0.00191805 6.15137 0.00191805C14.667 0 23.1827 0 31.6983 0H32.0559V0.52171C32.0559 3.13793 32.0559 5.75416 32.0559 8.36942C32.0559 9.4934 32.6082 10.0496 33.7232 10.0496C37.1834 10.0506 40.6445 10.0525 44.1046 10.0487C45.2388 10.0468 46.2743 10.3709 47.21 10.9952C48.3548 11.7586 48.954 12.8711 48.9732 14.2224C49.0153 17.2049 48.9971 20.1875 48.9866 23.171C48.9837 23.9843 48.3672 24.577 47.5504 24.5952C46.8332 24.6105 46.1151 24.6077 45.398 24.5952C45.1525 24.5904 45.0423 24.6604 44.9684 24.9117C44.2273 27.4282 42.1277 29.0211 39.6061 29.001C37.122 28.9808 35.0444 27.3418 34.3378 24.8484C34.3167 24.7736 34.2783 24.7026 34.2361 24.6H33.8133C29.2688 24.6 24.7234 24.6048 20.1789 24.5914C19.8098 24.5904 19.6755 24.6949 19.572 25.0555C18.8913 27.4214 16.7063 29.023 14.2432 29.001C11.8176 28.9789 9.67095 27.3332 9.00654 24.9836C8.97202 24.8628 8.93559 24.7429 8.8934 24.6C7.9845 24.6 7.09286 24.6029 6.20218 24.6C5.17631 24.5961 4.59723 24.0227 4.59435 23.0051C4.59051 21.7929 4.59435 20.5807 4.59435 19.3685C4.59435 19.2131 4.59435 19.0587 4.59435 18.8583C3.6749 18.8583 2.79956 18.819 1.92997 18.8688C1.03833 18.9197 0.383502 18.6329 0.000958754 17.8053V17.04C0.382543 16.2123 1.03833 15.9668 1.92805 15.9735C6.00851 16.0052 10.089 15.9841 14.1704 15.9908C14.8367 15.9918 15.3602 15.7674 15.6536 15.1507C16.1282 14.1552 15.3966 13.1185 14.2183 13.1176C10.1216 13.1137 6.02481 13.0984 1.92805 13.13C1.03833 13.1367 0.383502 12.8903 0.000958754 12.0636V11.2983L0 11.2945ZM11.6747 23.5163C11.6824 24.9683 12.8789 26.1373 14.3497 26.1287C15.7734 26.12 16.9441 24.9203 16.9354 23.4789C16.9268 22.0413 15.7408 20.8598 14.3123 20.8665C12.8463 20.8742 11.6671 22.0586 11.6747 23.5163ZM37.0319 23.4789C37.0242 24.9376 38.2016 26.12 39.6694 26.1287C41.097 26.1373 42.2839 24.9548 42.2926 23.5163C42.3012 22.0758 41.1315 20.877 39.7068 20.8665C38.238 20.8559 37.0395 22.0269 37.0319 23.4789Z"
                                        fill="white"/>
                                    <path
                                        d="M34.9434 7.15057V0.324219C38.881 1.07514 40.9864 3.89851 42.7869 7.15153H34.9434V7.15057Z"
                                        fill="white"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_4_1401">
                                        <rect width="49" height="29" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <div className={'pd-new-top-div'}>
                                <p className={'pd-new-top-p1'}>FREE WORLDWIDE SHIPPING</p>
                                <p className={'pd-new-top-p2'}>Limited time only*</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={'pd-new-top-col-mobile'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38"
                                 viewBox="0 0 38 38"
                                 fill="none">
                                <g clip-path="url(#clip0_4_1408)">
                                    <path
                                        d="M36.7392 38H33.252C33.252 31.7559 33.2381 25.5108 33.2659 19.2666C33.2708 18.2507 32.6404 17.4092 31.4133 17.4132C23.1414 17.439 14.8705 17.439 6.59867 17.4132C5.38045 17.4092 4.7411 18.2428 4.74605 19.2676C4.77381 25.5117 4.75993 31.7559 4.75993 38.001H1.27177C0.335057 37.6779 -0.00295428 37.0138 1.94288e-05 36.0366C0.0198441 28.6061 0.014888 21.1755 0.00299314 13.745C0.0020019 13.1117 0.22503 12.6815 0.747411 12.3237C6.53325 8.35129 12.3102 4.36595 18.0891 0.383577C18.8345 -0.129829 19.1844 -0.128838 19.9387 0.390515C25.6562 4.32927 31.3726 8.27101 37.095 12.2048C37.4648 12.4595 37.8018 12.7291 38.001 13.1404V36.7383C37.7948 37.3736 37.3736 37.7929 36.7392 38Z"
                                        fill="white"/>
                                    <path
                                        d="M20.3412 38.0007C19.9169 37.7648 19.791 37.4031 19.795 36.9253C19.8138 34.9847 19.802 33.0441 19.8029 31.1034C19.8029 30.3403 20.0646 30.0816 20.8299 30.0796C21.6556 30.0776 22.4813 30.0796 23.3645 30.0796C23.3645 30.4671 23.3615 30.82 23.3645 31.1728C23.3734 31.9409 23.8511 32.4544 24.55 32.4514C25.2409 32.4484 25.7236 31.9271 25.7365 31.1629C25.7424 30.819 25.7365 30.4741 25.7365 30.0796C26.0001 30.0796 26.2311 30.0796 26.4621 30.0796C27.1173 30.0796 27.7725 30.0697 28.4267 30.0836C28.9719 30.0945 29.2901 30.3968 29.293 30.9379C29.3039 33.0025 29.297 35.066 29.298 37.1305C29.298 37.5508 29.075 37.8174 28.7231 38.0007H20.3382H20.3412Z"
                                        fill="white"/>
                                    <path
                                        d="M9.28599 38.0006C8.84489 37.7845 8.70215 37.4228 8.70512 36.945C8.71801 35.0044 8.71008 33.0638 8.71107 31.1231C8.71107 30.354 8.98961 30.0805 9.76674 30.0795C10.5805 30.0785 11.3943 30.0795 12.2736 30.0795C12.2736 30.4957 12.2607 30.8853 12.2765 31.2738C12.3003 31.8397 12.6621 32.2956 13.1637 32.4225C13.6712 32.5513 14.2184 32.3432 14.4692 31.8784C14.5752 31.6811 14.6208 31.4373 14.6377 31.2094C14.6644 30.8545 14.6446 30.4967 14.6446 30.1221C14.7536 30.1052 14.8349 30.0814 14.9172 30.0805C15.7082 30.0775 16.4992 30.0725 17.2902 30.0805C17.9087 30.0864 18.2031 30.3778 18.2051 30.9913C18.2101 33.0182 18.1992 35.045 18.2131 37.0729C18.216 37.5139 18.0148 37.7875 17.6689 37.9996H9.28401L9.28599 38.0006Z"
                                        fill="white"/>
                                    <path
                                        d="M17.818 20.5894C17.818 21.0077 17.8121 21.3783 17.819 21.748C17.8329 22.4448 18.3404 22.9542 19.0095 22.9513C19.6786 22.9493 20.1772 22.4388 20.19 21.7371C20.197 21.3684 20.191 20.9987 20.191 20.5805C20.8205 20.5805 21.4222 20.5805 22.0238 20.5805C22.3331 20.5805 22.6434 20.5676 22.9506 20.5864C23.4482 20.6171 23.7476 20.9274 23.7496 21.4279C23.7555 23.5053 23.7555 25.5827 23.7496 27.6611C23.7476 28.1775 23.4284 28.4976 22.912 28.4986C20.303 28.5046 17.6941 28.5046 15.0842 28.4986C14.5866 28.4976 14.2605 28.1795 14.2595 27.6869C14.2516 25.5966 14.2525 23.5073 14.2595 21.417C14.2605 20.9472 14.539 20.6112 14.995 20.5973C15.9188 20.5696 16.8446 20.5894 17.818 20.5894Z"
                                        fill="white"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_4_1408">
                                        <rect width="38" height="38" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <div className={'pd-new-top-div'}>
                                <p className={'pd-new-top-p1'}>UK STOCK HELD</p>
                                <p className={'pd-new-top-p2'}>All four frame options available</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={'pd-new-top-col-mobile'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="43" viewBox="0 0 40 43"
                                 fill="none">
                                <g clip-path="url(#clip0_2419_2)">
                                    <path
                                        d="M18.8644 34.6797C23.8508 29.8733 28.8037 25.0383 33.7314 20.1746C35.2022 18.7224 35.2608 17.123 33.8403 15.6709C31.3011 13.0775 28.6989 10.5372 26.0591 8.03788C24.6972 6.74936 22.9332 6.72072 21.5839 8.01743C16.5011 12.9179 11.4477 17.8471 6.44457 22.8253C4.95704 24.3061 4.99056 25.8318 6.46133 27.3249C8.9629 29.861 11.5231 32.344 14.1295 34.7738C14.7371 35.3383 15.6296 35.6124 16.5305 36.0951C17.3979 35.5796 18.2568 35.2565 18.8602 34.6756L18.8644 34.6797ZM15.1393 33.0639C12.8305 30.8182 10.572 28.5316 8.2338 26.3145C7.2491 25.3819 7.33709 24.6537 8.25894 23.7579C13.0274 19.1356 17.7834 14.4928 22.5183 9.83364C23.3438 9.01962 24.0436 8.79464 24.9612 9.70274C27.3413 12.0671 29.7507 14.4028 32.1726 16.7262C32.9981 17.5198 32.9227 18.207 32.1307 18.976C27.27 23.7047 22.4303 28.4539 17.5696 33.1785C17.247 33.4935 16.7986 33.6775 16.3545 33.9557C15.8936 33.6203 15.4745 33.383 15.1435 33.0599L15.1393 33.0639Z"
                                        fill="white"/>
                                    <path
                                        d="M10.0441 36.508C-1.88966 28.7155 -0.804386 11.5719 12.0303 5.31334C15.2568 3.74257 18.6676 3.18216 22.5436 3.68939C22.1497 4.02072 21.9193 4.1189 21.8522 4.28252C21.693 4.67521 21.6092 5.09654 21.4961 5.5056C21.9402 5.5056 22.4556 5.65286 22.816 5.48515C23.7127 5.06382 24.6136 4.58522 25.3553 3.95527C25.6528 3.70166 25.791 2.80992 25.5732 2.51131C24.9279 1.64411 24.0982 0.891443 23.2685 0.175594C23.0464 -0.0166622 22.4766 -0.0616584 22.2377 0.0856018C22.045 0.204228 22.0408 0.72782 22.0869 1.05507C22.1246 1.33731 22.3551 1.59093 22.5478 1.9509C22.0743 1.9509 21.7475 1.9509 21.4164 1.9509C21.0267 1.9509 20.6412 1.93454 20.2516 1.94272C12.2189 2.08998 6.08855 5.55469 2.40953 12.4841C-1.24017 19.3562 -0.716391 26.2979 3.81325 32.6547C5.32174 34.7736 7.6557 36.3403 9.67959 38.0828C9.9729 38.3365 10.6475 38.1647 11.1462 38.1892C10.9199 37.7188 10.7062 37.2402 10.4506 36.7861C10.3794 36.6593 10.1824 36.6021 10.0441 36.5121V36.508Z"
                                        fill="white"/>
                                    <path
                                        d="M39.8407 18.8084C39.1075 12.8034 35.9019 8.17698 30.6851 4.92907C30.2702 4.67137 29.6082 4.79408 29.0593 4.73682C29.3274 5.23177 29.583 5.73491 29.8764 6.21351C29.9518 6.34032 30.1487 6.39349 30.287 6.48349C41.6635 13.9897 41.0894 30.3969 29.185 37.085C25.8537 38.9585 22.2627 39.752 18.6591 39.3634C18.8477 38.6394 18.9985 38.0545 19.1535 37.4695C18.5627 37.5677 17.9258 37.5636 17.3895 37.7886C16.631 38.1035 15.8852 38.5208 15.2524 39.0362C14.9717 39.2653 14.7454 40.0138 14.9046 40.2184C15.6421 41.1633 16.4886 42.0305 17.3769 42.8486C17.5822 43.0368 18.1772 43.049 18.4203 42.8895C18.6046 42.7709 18.6004 42.235 18.5334 41.9119C18.4747 41.6419 18.2066 41.4169 17.9049 40.9997C18.546 40.9997 18.9734 40.9997 19.405 40.9997C32.1265 41.1101 41.3492 31.1741 39.8407 18.8043V18.8084Z"
                                        fill="white"/>
                                    <path
                                        d="M22.5602 25.8032C22.9332 25.4473 23.2977 25.0791 23.6623 24.7151C24.1651 24.216 24.6637 23.717 25.1666 23.222C25.2294 23.1607 25.2965 23.0952 25.3593 23.0338C24.8565 22.543 24.3662 22.0644 23.8718 21.5817C23.8425 21.6103 23.8173 21.6349 23.7922 21.6594C22.9332 22.498 22.0742 23.3366 21.2194 24.171C21.123 24.2651 21.0308 24.3551 20.926 24.4369C20.3352 24.936 19.6522 25.1487 18.877 25.0341C17.9929 24.9032 17.2973 24.4574 16.7861 23.7497C16.4509 23.2875 16.2749 22.768 16.3084 22.1953C16.3461 21.5367 16.6436 20.9886 17.1087 20.5304C18.0264 19.6223 18.9566 18.7224 19.8827 17.8184C19.9036 17.7979 19.9288 17.7734 19.9539 17.7488C19.4553 17.2621 18.9692 16.7876 18.4706 16.3008C18.4371 16.3294 18.4119 16.3499 18.3868 16.3744C17.9217 16.8203 17.4565 17.2662 16.9956 17.712C16.5389 18.1538 16.0738 18.5956 15.6254 19.0496C15.4368 19.2378 15.2608 19.4382 15.1058 19.655C14.3809 20.6695 14.075 21.7944 14.2133 23.0257C14.3683 24.4001 15.022 25.5127 16.1701 26.3308C17.0459 26.9567 18.039 27.243 19.1201 27.2226C20.4567 27.194 21.6049 26.7154 22.5602 25.8073V25.8032Z"
                                        fill="white"/>
                                    <path
                                        d="M21.5043 17.712C21.3576 17.7284 21.278 17.892 21.3576 18.0106C21.3828 18.0475 21.4163 18.0843 21.4456 18.117C21.6384 18.3379 21.8311 18.5588 22.0322 18.7838C21.9903 18.8001 21.9568 18.8165 21.9191 18.8329C21.1733 19.1356 20.4232 19.4342 19.6773 19.7369C19.5642 19.7819 19.5139 19.8637 19.5307 19.9618C19.5474 20.0559 19.6312 20.1214 19.7402 20.1214C21.102 20.1214 22.4638 20.1214 23.8257 20.1214C23.9137 20.1214 23.9765 20.0846 24.0142 20.0109C24.0561 19.9373 24.0394 19.8637 23.9891 19.7982C23.8969 19.6755 23.8047 19.5528 23.7125 19.4301C23.6162 19.3033 23.524 19.1765 23.4276 19.0456C23.4527 19.0333 23.4653 19.0251 23.4779 19.0169C23.8257 18.8451 24.1693 18.6692 24.5171 18.4974C24.7978 18.3583 25.0786 18.2193 25.3551 18.0802C25.4934 18.0107 25.5311 17.8552 25.4263 17.7652C25.3802 17.7243 25.3006 17.7039 25.2378 17.7039C24.0142 17.7039 22.7865 17.7039 21.5629 17.7039C21.542 17.7039 21.5168 17.7039 21.4959 17.7039L21.5043 17.712Z"
                                        fill="white"/>
                                    <path
                                        d="M20.2933 17.4136C20.7207 16.9963 21.1481 16.5791 21.5755 16.1618C21.697 16.0432 21.6929 15.945 21.5755 15.8264C21.2026 15.4624 20.8255 15.0942 20.4525 14.7301C20.3143 14.5952 20.2221 14.5952 20.0838 14.7301C19.7234 15.0819 19.3589 15.4296 18.9985 15.7814C18.9189 15.8591 18.8393 15.9369 18.7555 16.0187C19.2541 16.5055 19.7444 16.984 20.2388 17.4667C20.2598 17.4463 20.2766 17.4299 20.2933 17.4136Z"
                                        fill="white"/>
                                    <path
                                        d="M24.1567 21.2954C24.6554 21.7822 25.1414 22.2567 25.6359 22.7394C25.7197 22.6576 25.7993 22.5799 25.8789 22.5021C26.2435 22.1463 26.608 21.7863 26.9768 21.4304C27.0899 21.32 27.0899 21.2177 26.9768 21.1073C26.5913 20.7309 26.21 20.3587 25.8245 19.9824C25.7155 19.876 25.6108 19.876 25.5018 19.9824C25.0744 20.3996 24.647 20.8168 24.2196 21.2341C24.1986 21.2545 24.1819 21.2709 24.1567 21.2954Z"
                                        fill="white"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_2419_2">
                                        <rect width="40" height="43" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <div className={'pd-new-top-div'}>
                                <p className={'pd-new-top-p1'}>Free Flush-Fit Wall Mount</p>
                                <p className={'pd-new-top-p2'}>Magnetic design with twist-lock</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={'pd-new-top-col-mobile'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37"
                                 viewBox="0 0 37 37"
                                 fill="none">
                                <g clip-path="url(#clip0_4_1420)">
                                    <path
                                        d="M4.79591 7.39681C3.84355 6.44443 2.97672 5.57896 2.10988 4.71232C1.62908 4.2315 1.14711 3.75416 0.669777 3.27102C-0.158917 2.42987 -0.201681 1.28981 0.56229 0.532082C1.32279 -0.222169 2.46008 -0.172349 3.29918 0.667638C9.29883 6.66573 15.295 12.6661 21.2935 18.6665C26.29 23.6648 31.2852 28.6641 36.284 33.6589C36.6631 34.0377 36.959 34.4467 36.9902 35.004C37.0353 35.7965 36.6538 36.472 35.965 36.8103C35.2854 37.1439 34.4879 37.035 33.9077 36.5125C33.6396 36.2715 33.3922 36.0062 33.1368 35.7513C31.1847 33.7991 29.2314 31.8503 27.2874 29.8899C27.077 29.6779 26.8679 29.5945 26.5697 29.5945C18.9981 29.6026 11.4266 29.6026 3.85511 29.5991C1.94114 29.5991 0.449023 28.4127 0.0872641 26.6041C0.0225404 26.282 0.0213846 25.9426 0.0213846 25.6124C0.0179172 20.8714 0.0629927 16.1292 -0.000575253 11.3894C-0.0317813 9.03623 1.76083 7.26009 4.02385 7.39449C4.23767 7.40723 4.45265 7.39565 4.79591 7.39565V7.39681ZM3.75687 11.1043V25.8638H23.2433C22.4562 25.0736 21.7316 24.3367 20.9884 23.6184C20.9225 23.5547 20.7318 23.5952 20.607 23.6219C19.9748 23.7574 19.3495 24.0065 18.715 24.0297C14.6801 24.1803 11.8936 20.1936 13.3845 16.4351C13.4793 16.1964 13.4573 16.055 13.2759 15.8743C11.7572 14.3693 10.2512 12.8492 8.72788 11.3488C8.59265 11.2156 8.36034 11.1229 8.16964 11.1159C7.41954 11.0893 6.66712 11.1055 5.91586 11.1055C5.19581 11.1055 4.47692 11.1055 3.75571 11.1055L3.75687 11.1043Z"
                                        fill="white"/>
                                    <path
                                        d="M33.3143 11.1046C33.0958 11.1046 32.9259 11.1046 32.7572 11.1046C28.1052 11.1046 23.4531 11.1104 18.8011 11.093C18.3966 11.0918 17.9562 11.0072 17.5968 10.8323C16.8583 10.4731 16.5185 9.60302 16.7115 8.80358C16.8975 8.03427 17.5922 7.44801 18.3908 7.40167C18.6786 7.38545 18.9687 7.39588 19.2577 7.39588C23.9097 7.39588 28.5617 7.3924 33.2137 7.39819C35.0884 7.40051 36.5724 8.60082 36.933 10.3978C36.9896 10.6782 36.9966 10.9725 36.9977 11.2598C37.0012 16.0866 37.0023 20.9145 36.9977 25.7412C36.9966 27.1084 35.9621 27.9843 34.7139 27.6923C33.9522 27.515 33.379 26.843 33.3247 26.0575C33.3119 25.8698 33.3143 25.6821 33.3143 25.4944C33.3143 20.8843 33.3143 16.2731 33.3143 11.663V11.1034V11.1046Z"
                                        fill="white"/>
                                    <path
                                        d="M27.7688 16.6584C28.7928 16.6631 29.6111 17.488 29.6053 18.5111C29.5995 19.5306 28.7708 20.3451 27.7445 20.3405C26.7216 20.3347 25.8952 19.5028 25.9045 18.4879C25.9137 17.4683 26.7424 16.655 27.7688 16.6596V16.6584Z"
                                        fill="white"/>
                                    <path
                                        d="M9.24167 20.3394C8.2188 20.3324 7.40282 19.504 7.41207 18.481C7.42131 17.4614 8.25116 16.6504 9.27865 16.6585C10.3015 16.6666 11.1279 17.5031 11.1129 18.5169C11.0978 19.54 10.2703 20.3463 9.24167 20.3394Z"
                                        fill="white"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_4_1420">
                                        <rect width="37" height="37" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <div className={'pd-new-top-div'}>
                                <p className={'pd-new-top-p1'}>NO SUBSCRIPTION COSTS</p>
                                <p className={'pd-new-top-p2'}>No ongoing monthly payments</p>
                            </div>
                        </div>
                    </div>
                </Carousel>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                    padding: '0 8vw',
                    margin: '1rem 0 0 0'
                }}>
                    <Row className={'magic-switching-yang'} justify={"center"} style={{
                        // margin: '2vh 7vw 0 7vw',
                        // margin: '0 8vw',
                        width: '100%',
                        margin: 0,
                        display: isMobile ? "none" : "flex",
                        maxWidth: maxLimitTop, // transform: `translateX(-${activeIndex * 100}%)`,
                        // transition: 'transform 0.3s ease-out',
                        // backgroundColor: 'red'
                    }}>
                        <Col xs={24} lg={12} xl={6} className={`col-${activeIndex === 0 ? 'active' : 'no'}`}>
                            <div className={'pd-new-top-col'}>
                                <div className={'spacer'}></div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="49" height="29"
                                     viewBox="0 0 49 29"
                                     fill="none">
                                    <g clip-path="url(#clip0_4_1401)">
                                        <path
                                            d="M0 11.2945C0.382543 10.4668 1.03737 10.2146 1.92805 10.228C4.62215 10.2664 7.31817 10.2462 10.0132 10.2395C10.9931 10.2366 11.646 9.4934 11.5137 8.56219C11.413 7.85251 10.9576 7.47849 10.1264 7.47177C8.73904 7.45931 7.35173 7.46698 5.96441 7.46698C4.97593 7.46698 3.98746 7.47082 2.99802 7.46602C2.07762 7.46123 1.42854 6.85416 1.43717 6.01693C1.44484 5.19984 2.08721 4.60524 2.97885 4.59661C3.50137 4.59182 4.02293 4.59661 4.59339 4.59661C4.59339 3.55223 4.5886 2.55197 4.59435 1.5517C4.6001 0.591719 5.18974 0.00191805 6.15137 0.00191805C14.667 0 23.1827 0 31.6983 0H32.0559V0.52171C32.0559 3.13793 32.0559 5.75416 32.0559 8.36942C32.0559 9.4934 32.6082 10.0496 33.7232 10.0496C37.1834 10.0506 40.6445 10.0525 44.1046 10.0487C45.2388 10.0468 46.2743 10.3709 47.21 10.9952C48.3548 11.7586 48.954 12.8711 48.9732 14.2224C49.0153 17.2049 48.9971 20.1875 48.9866 23.171C48.9837 23.9843 48.3672 24.577 47.5504 24.5952C46.8332 24.6105 46.1151 24.6077 45.398 24.5952C45.1525 24.5904 45.0423 24.6604 44.9684 24.9117C44.2273 27.4282 42.1277 29.0211 39.6061 29.001C37.122 28.9808 35.0444 27.3418 34.3378 24.8484C34.3167 24.7736 34.2783 24.7026 34.2361 24.6H33.8133C29.2688 24.6 24.7234 24.6048 20.1789 24.5914C19.8098 24.5904 19.6755 24.6949 19.572 25.0555C18.8913 27.4214 16.7063 29.023 14.2432 29.001C11.8176 28.9789 9.67095 27.3332 9.00654 24.9836C8.97202 24.8628 8.93559 24.7429 8.8934 24.6C7.9845 24.6 7.09286 24.6029 6.20218 24.6C5.17631 24.5961 4.59723 24.0227 4.59435 23.0051C4.59051 21.7929 4.59435 20.5807 4.59435 19.3685C4.59435 19.2131 4.59435 19.0587 4.59435 18.8583C3.6749 18.8583 2.79956 18.819 1.92997 18.8688C1.03833 18.9197 0.383502 18.6329 0.000958754 17.8053V17.04C0.382543 16.2123 1.03833 15.9668 1.92805 15.9735C6.00851 16.0052 10.089 15.9841 14.1704 15.9908C14.8367 15.9918 15.3602 15.7674 15.6536 15.1507C16.1282 14.1552 15.3966 13.1185 14.2183 13.1176C10.1216 13.1137 6.02481 13.0984 1.92805 13.13C1.03833 13.1367 0.383502 12.8903 0.000958754 12.0636V11.2983L0 11.2945ZM11.6747 23.5163C11.6824 24.9683 12.8789 26.1373 14.3497 26.1287C15.7734 26.12 16.9441 24.9203 16.9354 23.4789C16.9268 22.0413 15.7408 20.8598 14.3123 20.8665C12.8463 20.8742 11.6671 22.0586 11.6747 23.5163ZM37.0319 23.4789C37.0242 24.9376 38.2016 26.12 39.6694 26.1287C41.097 26.1373 42.2839 24.9548 42.2926 23.5163C42.3012 22.0758 41.1315 20.877 39.7068 20.8665C38.238 20.8559 37.0395 22.0269 37.0319 23.4789Z"
                                            fill="white"/>
                                        <path
                                            d="M34.9434 7.15057V0.324219C38.881 1.07514 40.9864 3.89851 42.7869 7.15153H34.9434V7.15057Z"
                                            fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4_1401">
                                            <rect width="49" height="29" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <div className={'spacer'}></div>
                                <div className={'pd-new-top-div'}>
                                    <p className={'pd-new-top-p1'}>FREE WORLDWIDE SHIPPING</p>
                                    <p className={'pd-new-top-p2'}>Limited time only*</p>
                                </div>
                                <div className={'spacer'}></div>
                            </div>
                        </Col>

                        <Col xs={24} lg={12} xl={6} className={`col-${activeIndex === 1 ? 'active' : 'no'}`}>
                            <div className={'pd-new-top-col'}>
                                <div className={'spacer'}></div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38"
                                     viewBox="0 0 38 38"
                                     fill="none">
                                    <g clip-path="url(#clip0_4_1408)">
                                        <path
                                            d="M36.7392 38H33.252C33.252 31.7559 33.2381 25.5108 33.2659 19.2666C33.2708 18.2507 32.6404 17.4092 31.4133 17.4132C23.1414 17.439 14.8705 17.439 6.59867 17.4132C5.38045 17.4092 4.7411 18.2428 4.74605 19.2676C4.77381 25.5117 4.75993 31.7559 4.75993 38.001H1.27177C0.335057 37.6779 -0.00295428 37.0138 1.94288e-05 36.0366C0.0198441 28.6061 0.014888 21.1755 0.00299314 13.745C0.0020019 13.1117 0.22503 12.6815 0.747411 12.3237C6.53325 8.35129 12.3102 4.36595 18.0891 0.383577C18.8345 -0.129829 19.1844 -0.128838 19.9387 0.390515C25.6562 4.32927 31.3726 8.27101 37.095 12.2048C37.4648 12.4595 37.8018 12.7291 38.001 13.1404V36.7383C37.7948 37.3736 37.3736 37.7929 36.7392 38Z"
                                            fill="white"/>
                                        <path
                                            d="M20.3412 38.0007C19.9169 37.7648 19.791 37.4031 19.795 36.9253C19.8138 34.9847 19.802 33.0441 19.8029 31.1034C19.8029 30.3403 20.0646 30.0816 20.8299 30.0796C21.6556 30.0776 22.4813 30.0796 23.3645 30.0796C23.3645 30.4671 23.3615 30.82 23.3645 31.1728C23.3734 31.9409 23.8511 32.4544 24.55 32.4514C25.2409 32.4484 25.7236 31.9271 25.7365 31.1629C25.7424 30.819 25.7365 30.4741 25.7365 30.0796C26.0001 30.0796 26.2311 30.0796 26.4621 30.0796C27.1173 30.0796 27.7725 30.0697 28.4267 30.0836C28.9719 30.0945 29.2901 30.3968 29.293 30.9379C29.3039 33.0025 29.297 35.066 29.298 37.1305C29.298 37.5508 29.075 37.8174 28.7231 38.0007H20.3382H20.3412Z"
                                            fill="white"/>
                                        <path
                                            d="M9.28599 38.0006C8.84489 37.7845 8.70215 37.4228 8.70512 36.945C8.71801 35.0044 8.71008 33.0638 8.71107 31.1231C8.71107 30.354 8.98961 30.0805 9.76674 30.0795C10.5805 30.0785 11.3943 30.0795 12.2736 30.0795C12.2736 30.4957 12.2607 30.8853 12.2765 31.2738C12.3003 31.8397 12.6621 32.2956 13.1637 32.4225C13.6712 32.5513 14.2184 32.3432 14.4692 31.8784C14.5752 31.6811 14.6208 31.4373 14.6377 31.2094C14.6644 30.8545 14.6446 30.4967 14.6446 30.1221C14.7536 30.1052 14.8349 30.0814 14.9172 30.0805C15.7082 30.0775 16.4992 30.0725 17.2902 30.0805C17.9087 30.0864 18.2031 30.3778 18.2051 30.9913C18.2101 33.0182 18.1992 35.045 18.2131 37.0729C18.216 37.5139 18.0148 37.7875 17.6689 37.9996H9.28401L9.28599 38.0006Z"
                                            fill="white"/>
                                        <path
                                            d="M17.818 20.5894C17.818 21.0077 17.8121 21.3783 17.819 21.748C17.8329 22.4448 18.3404 22.9542 19.0095 22.9513C19.6786 22.9493 20.1772 22.4388 20.19 21.7371C20.197 21.3684 20.191 20.9987 20.191 20.5805C20.8205 20.5805 21.4222 20.5805 22.0238 20.5805C22.3331 20.5805 22.6434 20.5676 22.9506 20.5864C23.4482 20.6171 23.7476 20.9274 23.7496 21.4279C23.7555 23.5053 23.7555 25.5827 23.7496 27.6611C23.7476 28.1775 23.4284 28.4976 22.912 28.4986C20.303 28.5046 17.6941 28.5046 15.0842 28.4986C14.5866 28.4976 14.2605 28.1795 14.2595 27.6869C14.2516 25.5966 14.2525 23.5073 14.2595 21.417C14.2605 20.9472 14.539 20.6112 14.995 20.5973C15.9188 20.5696 16.8446 20.5894 17.818 20.5894Z"
                                            fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4_1408">
                                            <rect width="38" height="38" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <div className={'spacer'}></div>
                                <div className={'pd-new-top-div'}>
                                    <p className={'pd-new-top-p1'}>UK STOCK HELD</p>
                                    <p className={'pd-new-top-p2'}>All four frame options available</p>
                                </div>
                                <div className={'spacer'}></div>
                            </div>
                        </Col>

                        <Col xs={24} lg={12} xl={6} className={`col-${activeIndex === 2 ? 'active' : 'no'}`}>
                            <div className={'pd-new-top-col'}>
                                <div className={'spacer'}></div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="43" viewBox="0 0 40 43"
                                     fill="none">
                                    <g clip-path="url(#clip0_2419_2)">
                                        <path
                                            d="M18.8644 34.6797C23.8508 29.8733 28.8037 25.0383 33.7314 20.1746C35.2022 18.7224 35.2608 17.123 33.8403 15.6709C31.3011 13.0775 28.6989 10.5372 26.0591 8.03788C24.6972 6.74936 22.9332 6.72072 21.5839 8.01743C16.5011 12.9179 11.4477 17.8471 6.44457 22.8253C4.95704 24.3061 4.99056 25.8318 6.46133 27.3249C8.9629 29.861 11.5231 32.344 14.1295 34.7738C14.7371 35.3383 15.6296 35.6124 16.5305 36.0951C17.3979 35.5796 18.2568 35.2565 18.8602 34.6756L18.8644 34.6797ZM15.1393 33.0639C12.8305 30.8182 10.572 28.5316 8.2338 26.3145C7.2491 25.3819 7.33709 24.6537 8.25894 23.7579C13.0274 19.1356 17.7834 14.4928 22.5183 9.83364C23.3438 9.01962 24.0436 8.79464 24.9612 9.70274C27.3413 12.0671 29.7507 14.4028 32.1726 16.7262C32.9981 17.5198 32.9227 18.207 32.1307 18.976C27.27 23.7047 22.4303 28.4539 17.5696 33.1785C17.247 33.4935 16.7986 33.6775 16.3545 33.9557C15.8936 33.6203 15.4745 33.383 15.1435 33.0599L15.1393 33.0639Z"
                                            fill="white"/>
                                        <path
                                            d="M10.0441 36.508C-1.88966 28.7155 -0.804386 11.5719 12.0303 5.31334C15.2568 3.74257 18.6676 3.18216 22.5436 3.68939C22.1497 4.02072 21.9193 4.1189 21.8522 4.28252C21.693 4.67521 21.6092 5.09654 21.4961 5.5056C21.9402 5.5056 22.4556 5.65286 22.816 5.48515C23.7127 5.06382 24.6136 4.58522 25.3553 3.95527C25.6528 3.70166 25.791 2.80992 25.5732 2.51131C24.9279 1.64411 24.0982 0.891443 23.2685 0.175594C23.0464 -0.0166622 22.4766 -0.0616584 22.2377 0.0856018C22.045 0.204228 22.0408 0.72782 22.0869 1.05507C22.1246 1.33731 22.3551 1.59093 22.5478 1.9509C22.0743 1.9509 21.7475 1.9509 21.4164 1.9509C21.0267 1.9509 20.6412 1.93454 20.2516 1.94272C12.2189 2.08998 6.08855 5.55469 2.40953 12.4841C-1.24017 19.3562 -0.716391 26.2979 3.81325 32.6547C5.32174 34.7736 7.6557 36.3403 9.67959 38.0828C9.9729 38.3365 10.6475 38.1647 11.1462 38.1892C10.9199 37.7188 10.7062 37.2402 10.4506 36.7861C10.3794 36.6593 10.1824 36.6021 10.0441 36.5121V36.508Z"
                                            fill="white"/>
                                        <path
                                            d="M39.8407 18.8084C39.1075 12.8034 35.9019 8.17698 30.6851 4.92907C30.2702 4.67137 29.6082 4.79408 29.0593 4.73682C29.3274 5.23177 29.583 5.73491 29.8764 6.21351C29.9518 6.34032 30.1487 6.39349 30.287 6.48349C41.6635 13.9897 41.0894 30.3969 29.185 37.085C25.8537 38.9585 22.2627 39.752 18.6591 39.3634C18.8477 38.6394 18.9985 38.0545 19.1535 37.4695C18.5627 37.5677 17.9258 37.5636 17.3895 37.7886C16.631 38.1035 15.8852 38.5208 15.2524 39.0362C14.9717 39.2653 14.7454 40.0138 14.9046 40.2184C15.6421 41.1633 16.4886 42.0305 17.3769 42.8486C17.5822 43.0368 18.1772 43.049 18.4203 42.8895C18.6046 42.7709 18.6004 42.235 18.5334 41.9119C18.4747 41.6419 18.2066 41.4169 17.9049 40.9997C18.546 40.9997 18.9734 40.9997 19.405 40.9997C32.1265 41.1101 41.3492 31.1741 39.8407 18.8043V18.8084Z"
                                            fill="white"/>
                                        <path
                                            d="M22.5602 25.8032C22.9332 25.4473 23.2977 25.0791 23.6623 24.7151C24.1651 24.216 24.6637 23.717 25.1666 23.222C25.2294 23.1607 25.2965 23.0952 25.3593 23.0338C24.8565 22.543 24.3662 22.0644 23.8718 21.5817C23.8425 21.6103 23.8173 21.6349 23.7922 21.6594C22.9332 22.498 22.0742 23.3366 21.2194 24.171C21.123 24.2651 21.0308 24.3551 20.926 24.4369C20.3352 24.936 19.6522 25.1487 18.877 25.0341C17.9929 24.9032 17.2973 24.4574 16.7861 23.7497C16.4509 23.2875 16.2749 22.768 16.3084 22.1953C16.3461 21.5367 16.6436 20.9886 17.1087 20.5304C18.0264 19.6223 18.9566 18.7224 19.8827 17.8184C19.9036 17.7979 19.9288 17.7734 19.9539 17.7488C19.4553 17.2621 18.9692 16.7876 18.4706 16.3008C18.4371 16.3294 18.4119 16.3499 18.3868 16.3744C17.9217 16.8203 17.4565 17.2662 16.9956 17.712C16.5389 18.1538 16.0738 18.5956 15.6254 19.0496C15.4368 19.2378 15.2608 19.4382 15.1058 19.655C14.3809 20.6695 14.075 21.7944 14.2133 23.0257C14.3683 24.4001 15.022 25.5127 16.1701 26.3308C17.0459 26.9567 18.039 27.243 19.1201 27.2226C20.4567 27.194 21.6049 26.7154 22.5602 25.8073V25.8032Z"
                                            fill="white"/>
                                        <path
                                            d="M21.5043 17.712C21.3576 17.7284 21.278 17.892 21.3576 18.0106C21.3828 18.0475 21.4163 18.0843 21.4456 18.117C21.6384 18.3379 21.8311 18.5588 22.0322 18.7838C21.9903 18.8001 21.9568 18.8165 21.9191 18.8329C21.1733 19.1356 20.4232 19.4342 19.6773 19.7369C19.5642 19.7819 19.5139 19.8637 19.5307 19.9618C19.5474 20.0559 19.6312 20.1214 19.7402 20.1214C21.102 20.1214 22.4638 20.1214 23.8257 20.1214C23.9137 20.1214 23.9765 20.0846 24.0142 20.0109C24.0561 19.9373 24.0394 19.8637 23.9891 19.7982C23.8969 19.6755 23.8047 19.5528 23.7125 19.4301C23.6162 19.3033 23.524 19.1765 23.4276 19.0456C23.4527 19.0333 23.4653 19.0251 23.4779 19.0169C23.8257 18.8451 24.1693 18.6692 24.5171 18.4974C24.7978 18.3583 25.0786 18.2193 25.3551 18.0802C25.4934 18.0107 25.5311 17.8552 25.4263 17.7652C25.3802 17.7243 25.3006 17.7039 25.2378 17.7039C24.0142 17.7039 22.7865 17.7039 21.5629 17.7039C21.542 17.7039 21.5168 17.7039 21.4959 17.7039L21.5043 17.712Z"
                                            fill="white"/>
                                        <path
                                            d="M20.2933 17.4136C20.7207 16.9963 21.1481 16.5791 21.5755 16.1618C21.697 16.0432 21.6929 15.945 21.5755 15.8264C21.2026 15.4624 20.8255 15.0942 20.4525 14.7301C20.3143 14.5952 20.2221 14.5952 20.0838 14.7301C19.7234 15.0819 19.3589 15.4296 18.9985 15.7814C18.9189 15.8591 18.8393 15.9369 18.7555 16.0187C19.2541 16.5055 19.7444 16.984 20.2388 17.4667C20.2598 17.4463 20.2766 17.4299 20.2933 17.4136Z"
                                            fill="white"/>
                                        <path
                                            d="M24.1567 21.2954C24.6554 21.7822 25.1414 22.2567 25.6359 22.7394C25.7197 22.6576 25.7993 22.5799 25.8789 22.5021C26.2435 22.1463 26.608 21.7863 26.9768 21.4304C27.0899 21.32 27.0899 21.2177 26.9768 21.1073C26.5913 20.7309 26.21 20.3587 25.8245 19.9824C25.7155 19.876 25.6108 19.876 25.5018 19.9824C25.0744 20.3996 24.647 20.8168 24.2196 21.2341C24.1986 21.2545 24.1819 21.2709 24.1567 21.2954Z"
                                            fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2419_2">
                                            <rect width="40" height="43" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <div className={'spacer'}></div>
                                <div className={'pd-new-top-div'}>
                                    <p className={'pd-new-top-p1'}>Free Flush-Fit Wall Mount</p>
                                    <p className={'pd-new-top-p2'}>Magnetic design with twist-lock</p>
                                </div>
                                <div className={'spacer'}></div>
                            </div>
                        </Col>

                        <Col xs={24} lg={12} xl={6} className={`col-${activeIndex === 3 ? 'active' : 'no'}`}>
                            <div className={'pd-new-top-col'}>
                                <div className={'spacer'}></div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37"
                                     viewBox="0 0 37 37"
                                     fill="none">
                                    <g clip-path="url(#clip0_4_1420)">
                                        <path
                                            d="M4.79591 7.39681C3.84355 6.44443 2.97672 5.57896 2.10988 4.71232C1.62908 4.2315 1.14711 3.75416 0.669777 3.27102C-0.158917 2.42987 -0.201681 1.28981 0.56229 0.532082C1.32279 -0.222169 2.46008 -0.172349 3.29918 0.667638C9.29883 6.66573 15.295 12.6661 21.2935 18.6665C26.29 23.6648 31.2852 28.6641 36.284 33.6589C36.6631 34.0377 36.959 34.4467 36.9902 35.004C37.0353 35.7965 36.6538 36.472 35.965 36.8103C35.2854 37.1439 34.4879 37.035 33.9077 36.5125C33.6396 36.2715 33.3922 36.0062 33.1368 35.7513C31.1847 33.7991 29.2314 31.8503 27.2874 29.8899C27.077 29.6779 26.8679 29.5945 26.5697 29.5945C18.9981 29.6026 11.4266 29.6026 3.85511 29.5991C1.94114 29.5991 0.449023 28.4127 0.0872641 26.6041C0.0225404 26.282 0.0213846 25.9426 0.0213846 25.6124C0.0179172 20.8714 0.0629927 16.1292 -0.000575253 11.3894C-0.0317813 9.03623 1.76083 7.26009 4.02385 7.39449C4.23767 7.40723 4.45265 7.39565 4.79591 7.39565V7.39681ZM3.75687 11.1043V25.8638H23.2433C22.4562 25.0736 21.7316 24.3367 20.9884 23.6184C20.9225 23.5547 20.7318 23.5952 20.607 23.6219C19.9748 23.7574 19.3495 24.0065 18.715 24.0297C14.6801 24.1803 11.8936 20.1936 13.3845 16.4351C13.4793 16.1964 13.4573 16.055 13.2759 15.8743C11.7572 14.3693 10.2512 12.8492 8.72788 11.3488C8.59265 11.2156 8.36034 11.1229 8.16964 11.1159C7.41954 11.0893 6.66712 11.1055 5.91586 11.1055C5.19581 11.1055 4.47692 11.1055 3.75571 11.1055L3.75687 11.1043Z"
                                            fill="white"/>
                                        <path
                                            d="M33.3143 11.1046C33.0958 11.1046 32.9259 11.1046 32.7572 11.1046C28.1052 11.1046 23.4531 11.1104 18.8011 11.093C18.3966 11.0918 17.9562 11.0072 17.5968 10.8323C16.8583 10.4731 16.5185 9.60302 16.7115 8.80358C16.8975 8.03427 17.5922 7.44801 18.3908 7.40167C18.6786 7.38545 18.9687 7.39588 19.2577 7.39588C23.9097 7.39588 28.5617 7.3924 33.2137 7.39819C35.0884 7.40051 36.5724 8.60082 36.933 10.3978C36.9896 10.6782 36.9966 10.9725 36.9977 11.2598C37.0012 16.0866 37.0023 20.9145 36.9977 25.7412C36.9966 27.1084 35.9621 27.9843 34.7139 27.6923C33.9522 27.515 33.379 26.843 33.3247 26.0575C33.3119 25.8698 33.3143 25.6821 33.3143 25.4944C33.3143 20.8843 33.3143 16.2731 33.3143 11.663V11.1034V11.1046Z"
                                            fill="white"/>
                                        <path
                                            d="M27.7688 16.6584C28.7928 16.6631 29.6111 17.488 29.6053 18.5111C29.5995 19.5306 28.7708 20.3451 27.7445 20.3405C26.7216 20.3347 25.8952 19.5028 25.9045 18.4879C25.9137 17.4683 26.7424 16.655 27.7688 16.6596V16.6584Z"
                                            fill="white"/>
                                        <path
                                            d="M9.24167 20.3394C8.2188 20.3324 7.40282 19.504 7.41207 18.481C7.42131 17.4614 8.25116 16.6504 9.27865 16.6585C10.3015 16.6666 11.1279 17.5031 11.1129 18.5169C11.0978 19.54 10.2703 20.3463 9.24167 20.3394Z"
                                            fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4_1420">
                                            <rect width="37" height="37" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <div className={'spacer'}></div>
                                <div className={'pd-new-top-div'}>
                                    <p className={'pd-new-top-p1'}>NO SUBSCRIPTION COSTS</p>
                                    <p className={'pd-new-top-p2'}>No ongoing monthly payments</p>
                                </div>
                                <div className={'spacer'}></div>
                            </div>
                        </Col>
                    </Row>

                    <Row
                        style={{
                            // backgroundColor: '#f4f4f4',
                            // margin: '0 8vw 0 8vw',
                            margin: 0, width: '100%', maxWidth: maxLimitTop, // columnGap: '4rem'
                            justify: 'center', // backgroundColor: 'green'
                        }}
                    >

                        <Col xl={12} lg={24} md={24}>
                            <div style={{paddingTop: '2rem'}}>
                                <VerticalCarousel>
                                </VerticalCarousel>
                            </div>
                        </Col>
                        <Col xl={12} lg={22} md={22} xs={24} className={'new-jack-textura-copy'}>
                            <div style={{
                                display: 'flex', flexDirection: 'row-reverse', // paddingBottom: '30px',
                                paddingTop: '1.5rem'
                            }}>
                                <div className="spacer"></div>
                                <div style={{}}>

                                    <p style={{
                                        margin: 0, ...TitleFont
                                    }}>
                                        Textura Digital Canvas
                                    </p>
                                    <div style={{height: "7px"}}></div>
                                    <p style={{
                                        // marginTop: "-40px",
                                        // marginBottom: "-3px",
                                        fontFamily: "Proxima Nova Regular, sans-serif",
                                        fontWeight: '400',
                                        fontSize: '1.1rem',
                                        marginBottom: '0px'
                                    }}>
                                        Bring <span style={{fontWeight:'600'}}>£600 million</span> worth of art into your home.
                                    </p>
                                    {/*<p style={{*/}
                                    {/*    // marginTop: "-40px",*/}
                                    {/*    // marginBottom: "-3px",*/}
                                    {/*    fontFamily: "Proxima Nova Regular, sans-serif",*/}
                                    {/*    fontWeight: '600',*/}
                                    {/*    fontSize: '1rem',*/}
                                    {/*    marginBottom: '0px',*/}
                                    {/*    border: '2px solid #105B63',*/}
                                    {/*    padding: '0.5rem'*/}
                                    {/*}}>*/}
                                    {/*    We will not be shipping orders placed on our website until January 2nd. For*/}
                                    {/*    immediate delivery options please visit our*/}
                                    {/*    <span*/}
                                    {/*        onClick={_ => {*/}
                                    {/*            window.open('https://www.amazon.co.uk/Black-Textura-Digital-Canvas-Texture-Accurate/dp/B0BJVJJ678')*/}
                                    {/*        }}*/}
                                    {/*        style={{*/}
                                    {/*            color: '#149CE0',*/}
                                    {/*            fontWeight: '600',*/}
                                    {/*            cursor: "pointer",*/}
                                    {/*            textDecoration: "underline",*/}
                                    {/*        }}>&nbsp;Amazon Page</span>.*/}
                                    {/*</p>*/}
                                    <p style={{
                                        // marginTop: "-40px",
                                        // marginBottom: "-3px",
                                        fontFamily: "Proxima Nova Regular, sans-serif",
                                        fontWeight: '600',
                                        fontSize: '1rem',
                                        marginBottom: '0px',
                                        border: '2px solid #F19737',
                                        width: '18rem',
                                        padding: '0 1rem',
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}>
                                        Use code SAVE200 for £200 off
                                    </p>
                                    {/*<p style={{*/}
                                    {/*    color: '#F19737',*/}
                                    {/*    fontFamily: "Proxima Nova Regular, sans-serif",*/}
                                    {/*    fontWeight: "800",*/}
                                    {/*    fontSize: '0.8rem',*/}
                                    {/*    margin: '0rem 0 0 0'*/}
                                    {/*}}>Offer ends Sunday 1st December</p>*/}

                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                        <p style={{
                                            color: 'black',
                                            fontFamily: "Proxima Nova Regular, sans-serif",
                                            fontWeight: "800",
                                            fontSize: '1.4rem',
                                            margin: '0',
                                            // textDecoration: 'line-through'
                                        }}>
                                            £599
                                        </p>
                                        {/*<p style={{*/}
                                        {/*    color: 'black',*/}
                                        {/*    fontFamily: "Proxima Nova Regular, sans-serif",*/}
                                        {/*    fontWeight: "800",*/}
                                        {/*    fontSize: '1.4rem',*/}
                                        {/*    margin: '0',*/}
                                        {/*}}>*/}
                                        {/*    &nbsp;£499*/}
                                        {/*</p>*/}
                                        <p className={'product-price-klarna'}>
                                            or 3 interest-free payments of £199.66
                                        </p>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="11"
                                             viewBox="0 0 50 11" fill="none">
                                            <g clip-path="url(#clip0_2263_2)">
                                                <path
                                                    d="M48.5769 8.14573C47.7881 8.14877 47.1507 8.77589 47.1538 9.54633C47.1538 9.54708 47.1538 9.54784 47.1538 9.5486C47.1491 10.319 47.7858 10.9477 48.5746 10.9515C48.5753 10.9515 48.5761 10.9515 48.5769 10.9515C49.3618 10.9515 50 10.3228 50 9.54784C50.0047 8.7774 49.368 8.14877 48.5792 8.14497C48.5784 8.14497 48.5777 8.14497 48.5769 8.14497V8.14573ZM43.8929 7.06211C43.8929 6.00048 42.9729 5.14132 41.8379 5.14132C40.7028 5.14132 39.7828 6.002 39.7828 7.06211C39.7828 8.12222 40.7043 8.98215 41.8386 8.98215C42.9729 8.98215 43.8922 8.12298 43.8922 7.06211H43.8929ZM43.9007 3.32821H46.1678V10.7945H43.9007V10.3175C43.24 10.7634 42.4551 11.0015 41.6523 11.0008C39.445 11.0008 37.6562 9.23769 37.6562 7.06211C37.6562 4.88653 39.4458 3.12347 41.6523 3.12347C42.4869 3.12347 43.2602 3.37522 43.9007 3.8067V3.32821ZM25.7527 4.30112V3.32973H23.4305V10.7945H25.7581V7.30856C25.7581 6.13243 27.0508 5.50076 27.9475 5.50076H27.9739V3.32973C27.0524 3.32973 26.2077 3.71798 25.7519 4.30112H25.7527ZM19.9679 7.06211C19.9679 6.00048 19.0478 5.14132 17.9128 5.14132C16.7777 5.14132 15.8577 6.002 15.8577 7.06211C15.8577 8.12222 16.7792 8.98215 17.9135 8.98215C19.0478 8.98215 19.9671 8.12298 19.9671 7.06211H19.9679ZM19.9764 3.32821H22.245V10.7945H19.9764V10.3175C19.3351 10.7482 18.5626 11.0008 17.728 11.0008C15.5207 11.0008 13.7319 9.23769 13.7319 7.06211C13.7319 4.88653 15.5215 3.12347 17.728 3.12347C18.5626 3.12347 19.3359 3.37522 19.9764 3.8067V3.32821ZM33.626 3.12877C32.7208 3.12877 31.8636 3.40556 31.2891 4.16917V3.32897H29.0314V10.7937H31.3171V6.87102C31.3171 5.73659 32.0888 5.17924 33.0197 5.17924C34.0158 5.17924 34.5895 5.76617 34.5895 6.85509V10.7937H36.8542V6.04674C36.8542 4.30946 35.4521 3.12802 33.626 3.12802V3.12877ZM10.4284 10.7945H12.8026V0.00227492H10.4284V10.7937V10.7945ZM0 10.7968H2.51394V0H0.00155277L0 10.7968ZM8.79412 0C8.79412 2.3371 7.87022 4.51193 6.22273 6.12788L9.69705 10.7968H6.59229L2.8175 5.7237L3.79187 5.00407C5.40131 3.82187 6.34307 1.96629 6.33142 0H8.79334H8.79412Z"
                                                    fill="#0A0B09"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_2263_2">
                                                    <rect width="50" height="11" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>

                                    <p style={{
                                        ...PrimaryFont,
                                        fontWeight: "400",
                                        fontSize: '0.8rem',
                                        color: '#C6C6C6',
                                        margin: '3px 0'
                                    }}>
                                        PRICE INCLUDES VAT
                                    </p>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        marginBottom: '10px'
                                    }}>
                                        {[...Array(5)].map(() => <StarFilled
                                            style={{fontSize: '1rem', marginRight: '10px'}}/>)}
                                        <div onClick={() => scrollDown("#REVIEWS")}
                                             style={{
                                                 cursor: "pointer",
                                                 fontStyle: 'italic',
                                                 fontFamily: "Proxima Nova Regular, sans-serif",
                                                 fontWeight: '600',
                                                 fontSize: '0.9rem',
                                                 textDecoration: 'underline'
                                             }}>Read Reviews
                                        </div>
                                    </div>
                                    <ul style={{
                                        margin: '0 0 30px -1vw', fontSize: '1rem', // width: '28rem',
                                        fontFamily: "Proxima Nova Regular, sans-serif",
                                    }}>
                                        <li>27” specialised digital art frame</li>
                                        <li>FREE flush landscape/portrait wall mount included</li>
                                        <li>No batteries required – no charging, no downtime</li>
                                        <li>Vast curated art library – no subscription required</li>
                                        {/*<li>No ongoing subscription costs</li>*/}
                                        <li>Display your own photos and videos</li>
                                        <li>FREE SHIPPING WORLDWIDE* (limited time only*) - shipped within 2 working days</li>
                                    </ul>

                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        paddingBottom: '1rem'
                                    }}>
                                        <button
                                            className={color === 'a' ? 'color-btn black-btn color-btn-active' : 'color-btn black-btn'}
                                            value="a"
                                            style={{
                                                backgroundColor: "black", marginRight: '0.5rem'
                                            }}
                                            onClick={(e) => {
                                                document.getElementById('thumbnail-1').click();
                                                setColor(e.target.value);
                                            }}>
                                        </button>
                                        <button
                                            className={color === 'b' ? 'color-btn white-btn color-btn-active' : 'color-btn white-btn'}
                                            value="b"
                                            style={{
                                                backgroundColor: "white", marginRight: '0.5rem'
                                            }}
                                            onClick={(e) => {
                                                document.getElementById('thumbnail-2').click();
                                                setColor(e.target.value);
                                            }}>
                                        </button>
                                        <button
                                            className={color === 'd' ? 'color-btn walnut-btn color-btn-active' : 'color-btn walnut-btn'}
                                            value="d"
                                            style={{
                                                backgroundColor: "#773f1a", marginRight: '0.5rem'
                                            }}
                                            onClick={(e) => {
                                                document.getElementById('thumbnail-4').click();
                                                setColor(e.target.value);
                                            }}>
                                        </button>

                                        <button
                                            className={color === 'c' ? 'color-btn pine-btn color-btn-active' : 'color-btn pine-btn'}
                                            value="c"
                                            style={{
                                                backgroundColor: "#eed5ae", marginRight: '1rem'
                                            }}
                                            onClick={(e) => {
                                                document.getElementById('thumbnail-3').click();
                                                setColor(e.target.value);
                                            }}>
                                        </button>

                                        <span style={{
                                            fontSize: '0.9rem',
                                            fontFamily: "Proxima Nova Regular, sans-serif",
                                            fontWeight: '600'
                                        }}>
                                        {COLOR_CODE[color].toString().toUpperCase()}
                                            </span>
                                    </div>
                                    <p onClick={() => scrollDown("#BuyFrames")}
                                       style={{
                                           cursor: "pointer",
                                           fontStyle: 'italic',
                                           fontFamily: "Proxima Nova Regular, sans-serif",
                                           fontWeight: '600',
                                           fontSize: '0.9rem',
                                           textDecoration: 'underline'
                                       }}>Buy an extra frame</p>
                                    <button type="submit"
                                            className={"pay-button"}
                                            onClick={checkOut}
                                            style={{
                                                marginTop: '1em',
                                                fontFamily: "Proxima Nova Regular, sans-serif",
                                                fontWeight: '800',
                                                borderRadius: "5px",
                                                padding: '0.5em',
                                                width: '100%'
                                            }}
                                    >
                                        Add To Cart
                                    </button>
                                    <img src={klarma_icon} style={{
                                        width: '100%',
                                        height: 'auto'
                                    }}></img>
                                    {/*<div style={{*/}
                                    {/*    width: "100%", display: "flex", justifyContent: "center", padding: "5px"*/}
                                    {/*}}>*/}
                                    {/*    <img src={klarma_icon}></img>*/}
                                    {/*</div>*/}
                                </div>
                                <div className="spacer min-40px-gap-on-lg-screen"></div>
                            </div>
                            {/*<div style={{display: 'flex', flexDirection: 'row-reverse', paddingBottom: '30px', paddingTop: '2rem'}}>*/}
                            {/*    <div style={{padding: '0 10px'}}>*/}
                            {/*        <p style={{*/}
                            {/*            margin: 0,*/}
                            {/*            ...TitleFont*/}
                            {/*        }}>*/}
                            {/*            Textura Digital Canvas*/}
                            {/*        </p>*/}
                            {/*        <p style={{*/}
                            {/*            // marginTop: "-40px",*/}
                            {/*            marginBottom: "-3px",*/}
                            {/*            fontFamily: "Proxima Nova Regular, sans-serif",*/}
                            {/*            fontWeight: '600',*/}
                            {/*            fontSize: '1.1rem'*/}
                            {/*        }}>*/}
                            {/*            Bring art into your home through the power of technology.*/}
                            {/*        </p>*/}
                            {/*        <p style={{*/}
                            {/*            color: 'black',*/}
                            {/*            fontFamily: "Proxima Nova Regular, sans-serif",*/}
                            {/*            fontWeight: "800",*/}
                            {/*            fontSize: '1.2vw',*/}
                            {/*            margin: '-7px 0'*/}
                            {/*        }}>*/}
                            {/*            £599*/}
                            {/*        </p>*/}

                            {/*        <p style={{*/}
                            {/*            ...PrimaryFont,*/}
                            {/*            fontWeight: "400",*/}
                            {/*            fontSize: '1.2rem',*/}
                            {/*            color: '#C6C6C6',*/}
                            {/*            margin: '3px 0'*/}
                            {/*        }}>*/}
                            {/*            PRICE INCLUDES VAT*/}
                            {/*        </p>*/}
                            {/*        <div style={{*/}
                            {/*            display: 'flex',*/}
                            {/*            flexDirection: 'row',*/}
                            {/*            alignItems: 'center',*/}
                            {/*            marginBottom: '30px'*/}
                            {/*        }}>*/}
                            {/*            {[...Array(5)].map(() => <StarFilled*/}
                            {/*                style={{fontSize: '1rem', marginRight: '10px'}}/>)}*/}
                            {/*            <div onClick={() => scrollDown("#REVIEWS")}*/}
                            {/*                 style={{*/}
                            {/*                     cursor: "pointer",*/}
                            {/*                     fontStyle: 'italic',*/}
                            {/*                     fontFamily: "Proxima Nova Regular, sans-serif",*/}
                            {/*                     fontWeight: '600',*/}
                            {/*                     fontSize: '0.9rem'*/}
                            {/*                 }}>Read Reviews*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*        <ul style={{*/}
                            {/*            margin: '0 0 30px -1vw',*/}
                            {/*            fontSize: '1rem',*/}
                            {/*            // width: '28rem',*/}
                            {/*            fontFamily: "Proxima Nova Regular, sans-serif",*/}
                            {/*        }}>*/}
                            {/*            <li>27” specialised digital art canvas</li>*/}
                            {/*            <li>FREE flush landscape/portrait wall mount included</li>*/}
                            {/*            <li>Access to an extensive art library and marketplace</li>*/}
                            {/*            <li>No ongoing subscription costs</li>*/}
                            {/*            <li>Display your own photos and videos</li>*/}
                            {/*            <li>FREE SHIPPING WORLDWIDE* (limited time only) - shipped within 2 working*/}
                            {/*                days*/}
                            {/*            </li>*/}
                            {/*        </ul>*/}

                            {/*        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', paddingBottom: '1rem'}}>*/}
                            {/*            <button*/}
                            {/*                className={this.state.color === 'a' ?*/}
                            {/*                    'color-btn black-btn color-btn-active' : 'color-btn black-btn'}*/}
                            {/*                value="a"*/}
                            {/*                style={{*/}
                            {/*                    backgroundColor: "black",*/}
                            {/*                    marginRight: '0.5rem'*/}
                            {/*                }}*/}
                            {/*                onClick={(e) => {*/}
                            {/*                    document.getElementById('thumbnail-1').click();*/}
                            {/*                    this.setState({color: e.target.value});*/}
                            {/*                }}>*/}
                            {/*            </button>*/}
                            {/*            <button*/}
                            {/*                className={this.state.color === 'd' ?*/}
                            {/*                    'color-btn walnut-btn color-btn-active' : 'color-btn walnut-btn'}*/}
                            {/*                value="d"*/}
                            {/*                style={{*/}
                            {/*                    backgroundColor: "#773f1a",*/}
                            {/*                    marginRight: '0.5rem'*/}
                            {/*                }}*/}
                            {/*                onClick={(e) => {*/}
                            {/*                    document.getElementById('thumbnail-4').click();*/}
                            {/*                    this.setState({color: e.target.value});*/}
                            {/*                }}>*/}
                            {/*            </button>*/}

                            {/*            <button className={this.state.color === 'c' ?*/}
                            {/*                'color-btn pine-btn color-btn-active' : 'color-btn pine-btn'}*/}
                            {/*                    value="c"*/}
                            {/*                    style={{*/}
                            {/*                        backgroundColor: "#eed5ae",*/}
                            {/*                        marginRight: '1rem'*/}
                            {/*                    }}*/}
                            {/*                    onClick={(e) => {*/}
                            {/*                        document.getElementById('thumbnail-3').click();*/}
                            {/*                        this.setState({color: e.target.value});*/}
                            {/*                    }}>*/}
                            {/*            </button>*/}

                            {/*            <span style={{*/}
                            {/*                fontSize: '0.9rem',*/}
                            {/*                fontFamily: "Proxima Nova Regular, sans-serif",*/}
                            {/*                fontWeight: '600'*/}
                            {/*            }}>*/}
                            {/*    {COLOR_CODE[this.state.color].toString().toUpperCase()}*/}
                            {/*        </span>*/}
                            {/*        </div>*/}

                            {/*        <button type="submit"*/}
                            {/*                className={"pay-button"}*/}
                            {/*                onClick={this.checkOut}*/}
                            {/*                style={{*/}
                            {/*                    marginTop: '1em',*/}
                            {/*                    fontFamily: "Proxima Nova Regular, sans-serif",*/}
                            {/*                    fontWeight: '800',*/}
                            {/*                    borderRadius: "5px",*/}
                            {/*                    padding: '0.5em',*/}
                            {/*                    width: '100%'*/}
                            {/*                }}*/}
                            {/*        >*/}
                            {/*            BUY NOW*/}
                            {/*        </button>*/}
                            {/*    </div>*/}
                            {/*    <div className="spacer min-40px-gap-on-lg-screen" ></div>*/}
                            {/*</div>*/}

                        </Col>
                    </Row>
                </div>


                {/*Product Row*/}


                {/*Others*/}
                <Row style={{
                    margin: windowWidth > 920 ? "4vh 0vw -2vh 54vw" : '4vh 0vw -2vh 10vw',
                    display: "flex",
                    width: windowWidth > 920 ? '30vw' : '80vw',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    flexDirection: "column"
                }}>
                    <p>
                        {`*Free shipping on all UK and international orders placed before ${formattedDate}. 
                        Please note that while shipping is free, any additional customs duties, taxes, or import charges applicable in your country are the responsibility of the recipient and are not covered under this promotion.`}
                    </p>
                </Row>
                <Row justify={"center"}
                     style={{
                         backgroundColor: '#f4f4f4', paddingTop: '3rem',
                     }}
                >
                    <Col lg={20} xs={20}>
                        <div className="video-container">
                            <Image
                                height={'100%'}
                                width={'100%'}
                                src={Transforming_Img}
                                preview={false}
                                style={{
                                    borderRadius: '15px', objectFit: 'cover', // objectPosition: 'top',
                                }}
                            />
                        </div>
                    </Col>
                </Row>

                <Row justify={"center"}
                     style={{
                         backgroundColor: '#f4f4f4', paddingTop: '1.5rem', paddingBottom: '4rem'
                     }}
                >
                    <Col lg={10} xs={20} style={{
                        alignItems: "center"
                    }}>
                        <div className="text-container m-title-small"
                             style={{}}>
                            <p style={{
                                ...TitleFont, fontWeight: 700, marginRight: '40px', marginBottom: 0
                            }}>
                                Transforming the World Around You.
                            </p>
                        </div>
                    </Col>

                    <Col lg={10} xs={20}>
                        <div className="text-container">
                            <p style={{fontFamily: "Proxima Nova, sans-serif", fontSize: '1rem'}}>
                                {TEXTURA_TEXT["Transforming the World Around You"]}
                            </p>
                        </div>
                    </Col>
                </Row>

                {/*Left-Img-Right-Text Section*/}
                <Row style={{
                    backgroundColor: 'black', // paddingBottom: '2rem',
                    padding: 0, overflow: "hidden"
                }}
                     className={"img-text-zone"}
                >
                    <Col span={10} lg={10} xs={0}>
                        <div className="video-container"
                             style={{marginLeft: '0', marginBottom: '-10%'}}>
                            <Image
                                src={LifeLike_Img}
                                preview={false}
                            />
                        </div>
                    </Col>

                    <Col span={0} lg={0} xs={24}>
                        <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
                            <img
                                style={{maxHeight: '40rem', maxWidth: '100%', objectFit: 'contain'}}
                                src={mLifeLike_Img}
                            />
                        </div>
                    </Col>

                    <Col span={10} lg={10} xs={20}>
                        <div style={{
                            paddingLeft: '10%', // paddingBottom: '5rem',
                            // backgroundColor: 'red',
                            display: 'flex', flexDirection: 'column', width: '110%', height: '100%'
                        }}>
                            <div className='spacer' style={{minHeight: '30px'}}></div>
                            <h2 className="title-app"
                                style={{
                                    color: 'white', ...TitleFont, marginBottom: 0
                                }}>
                                Lifelike Textures.
                            </h2>
                            <p className="text-content-app"
                               style={{
                                   color: 'white', fontFamily: "Proxima Nova, sans-serif", fontWeight: '500',
                               }}>
                                {TEXTURA_TEXT['Lifelike Textures']}
                            </p>
                            <div className='spacer' style={{minHeight: '30px'}}></div>
                        </div>
                    </Col>
                </Row>

                <Row justify={"center"}
                     style={{
                         backgroundColor: '#ececec',
                         margin: "5rem 8vw 0 8vw",
                         borderRadius: '15px',
                         overflow: 'hidden'
                     }}
                >
                    <Col
                        span={12}
                        lg={12}
                        xs={24}
                        // xs={}
                        style={{
                            textAlign: "center",
                        }}>
                        <div style={{
                            marginLeft: '10%', display: 'flex', flexDirection: 'column', height: '100%'
                        }}>
                            <div className='spacer' style={{minHeight: '30px'}}></div>
                            <h2 className="title-app"
                                style={{
                                    color: 'black', ...TitleFont, textAlign: 'left', marginBottom: 0, marginTop: 0
                                }}
                            >
                                Made for You.
                            </h2>
                            <p className="text-content-app" style={{color: 'black', width: '80%'}}>
                                {TEXTURA_TEXT["Made for You"]}
                            </p>
                            <div className='spacer' style={{minHeight: '30px'}}></div>
                        </div>
                    </Col>
                    <Col span={12} lg={{span: 12}} xs={24} style={{
                        backgroundColor: '#ececec'
                    }}>
                        <div className="video-container" style={{display: "flex"}}>
                            <Image
                                src={MadeForYou_Img}
                                preview={false}
                                style={{
                                    borderTopRightRadius: '15px', borderBottomRightRadius: '15px',
                                }}
                            />
                        </div>
                    </Col>
                </Row>

                {/*<Row justify={"center"}*/}
                {/*     style={{*/}
                {/*         backgroundColor: '#ececec',*/}
                {/*         margin: "5rem 8vw 0 8vw",*/}
                {/*         borderRadius: "15px",*/}
                {/*         overflow: "hidden"*/}
                {/*     }}*/}
                {/*>*/}
                {/*    <Col span={10} lg={{span: 10}} xs={24}>*/}
                {/*        <img*/}
                {/*            src={install1}*/}
                {/*            style={{width: '100%', height: '100%', objectFit: 'cover'}}*/}
                {/*            preview={false}*/}
                {/*        />*/}
                {/*    </Col>*/}

                {/*    <Col span={14} lg={14} xs={24}>*/}
                {/*        <div style={{*/}
                {/*            marginLeft: '10%',*/}
                {/*            display: 'flex',*/}
                {/*            flexDirection: 'column',*/}
                {/*            height: '100%'*/}
                {/*        }}>*/}
                {/*            <div className='spacer' style={{minHeight: '30px'}}></div>*/}
                {/*            <h2 className="title-app"*/}
                {/*                style={{*/}
                {/*                    color: 'black',*/}
                {/*                    ...TitleFont,*/}
                {/*                    textAlign: 'left',*/}
                {/*                    marginBottom: 0,*/}
                {/*                    marginTop: 0,*/}
                {/*                    marginRight: "10px"*/}
                {/*                }}*/}
                {/*            >*/}
                {/*                Installs made easy.*/}
                {/*            </h2>*/}
                {/*            <p className="text-content-app"*/}
                {/*               style={{color: 'black', width: '80%'}}>*/}
                {/*                {TEXTURA_TEXT["Installs made easy"]}*/}
                {/*            </p>*/}
                {/*            <div className='spacer' style={{minHeight: '30px'}}></div>*/}
                {/*        </div>*/}
                {/*    </Col>*/}

                {/*</Row>*/}


                <Row justify={"center"}
                     style={{
                         backgroundColor: '#ececec',
                         margin: "5rem 8vw 0 8vw",
                         borderRadius: "15px",
                         overflow: "hidden"
                     }}
                >
                    <Col span={10} lg={{span: 10}} xs={24}>
                        <img
                            onMouseEnter={() => {
                                setInstallDemo(install2)
                            }}
                            onMouseLeave={() => {
                                setInstallDemo(install1)
                            }}
                            src={installDemo}
                            // className={'product-details-image'}
                            style={{width: '100%', height: '100%', objectFit: 'cover'}}
                        />
                    </Col>

                    <Col span={14} lg={14} xs={24}>
                        <div style={{
                            marginLeft: '10%', display: 'flex', flexDirection: 'column', height: '100%'
                        }}>
                            <div className='spacer' style={{minHeight: '30px'}}></div>
                            <h2 className="title-app"
                                style={{
                                    color: 'black', ...TitleFont,
                                    textAlign: 'left',
                                    marginBottom: 0,
                                    marginTop: 0,
                                    marginRight: "10px"
                                }}
                            >
                                Installs made easy.
                            </h2>
                            <p className="text-content-app"
                               style={{color: 'black', width: '80%'}}>
                                Installing your Textura digital canvas is a breeze.
                                Just attach the provided mounting plate to your wall,
                                connect the discreet slim cable then hang the digital art frame in landscape or portrait orientation—it's that simple!
                                It's easier than hanging a traditional picture frame or art canvas.
                                At any point the canvas can be taken off the wall and changed to the other orientation.
                                Plus, we include a mounting template and spirit level for added convenience and to
                                ensure a perfectly straight installation.
                            </p>
                            <div className='spacer' style={{minHeight: '30px'}}></div>
                        </div>
                    </Col>

                </Row>
                <Row justify={"center"} style={{margin: "5rem 8vw 0 8vw",}}>
                    <img src={KlarnaImg} style={{width: '90vw'}}/>
                </Row>

                <Row justify={"center"}
                     style={{
                         backgroundColor: '#2c2e2d',
                         margin: "5rem 8vw 0 8vw",
                         borderRadius: "15px",
                         overflow: 'hidden'
                     }}
                >
                    <Col span={13} lg={13}
                         xs={24}>
                        <div style={{
                            display: "flex", flexDirection: "column", height: "100%", margin: "0 4vw",

                        }}>
                            <div className="spacer"></div>
                            <h2 className="title-app"
                                style={{
                                    ...TitleFont,
                                    color: 'white',
                                    textAlign: 'left',
                                    lineHeight: 1,
                                    marginBottom: 0,
                                    marginTop: '3rem'
                                }}
                            >
                                The Vieunite App.
                            </h2>
                            <p className="text-content-app"
                               style={{color: 'white', lineHeight: 1.3}}>
                                {TEXTURA_TEXT["The Vieunite App 1"]}
                            </p>
                            <p className="text-content-app"
                               style={{color: 'white', lineHeight: 1.3}}>
                                {TEXTURA_TEXT["The Vieunite App 2"]}
                            </p>

                            <div style={{
                                // display: "flex",
                                // justifyContent: "",
                                // backgroundColor: 'red',
                                // alignItems: "flex-start",
                                margin: "0 0 3rem 0"
                            }}>
                                <button className="homeMainButton"
                                        style={{width: "19rem", marginRight: "2rem", marginBottom: '1rem'}}
                                        onClick={_ => window.open(
                                            "https://apps.apple.com/gb/app/vieunite-discover-share-art/id1644381065",
                                            '_blank' // <- This is what makes it open in a new window.
                                        )}
                                >
                                    <a className={'homeMainButtonLnk homeOverV'} href="/digital-canvas">
                                        IOS
                                    </a>
                                </button>
                                <button className="homeMainButton"
                                        style={{width: "19rem", marginRight: "2rem"}}
                                        onClick={_ => window.open(
                                            "https://play.google.com/store/apps/details?id=com.app.vieunite&pcampaignid=offical_website",
                                            '_blank' // <- This is what makes it open in a new window.
                                        )}
                                >
                                    <a className={'homeMainButtonLnk homeOverV'}>
                                        GOOGLE PLAY
                                    </a>
                                </button>
                            </div>
                        </div>
                    </Col>

                    <Col span={11} lg={{span: 11}} xs={24} style={{
                        backgroundColor: '#2c2e2d',
                    }}>
                        <div className="video-container" style={{display: "flex"}}>
                            <video playsInline loop autoPlay ref={makeMuted} muted rel={"preload"} style={{
                                width: '100%', minHeight: '75vh', height: 'auto', objectFit: "cover"
                            }}>
                                <source src={Vieunite_App_Vd2}></source>
                            </video>
                        </div>
                    </Col>
                </Row>

                {/*Phone Section*/}
                {/*<Row justify={"center"}*/}
                {/*     style={{*/}
                {/*         backgroundColor: '#f4f4f4',*/}
                {/*     }}*/}
                {/*     className={"img-text-zone m-img-text"}*/}
                {/*>*/}
                {/*    <Col className={'m-padding-tb'} span={10} lg={10} xs={{...MWidth}}>*/}
                {/*        <div className="video-container"*/}
                {/*             style={{*/}
                {/*                 background: 'linear-gradient(0deg, rgba(172,203,238,1) 4%, rgba(231,240,253,1) 100%)',*/}
                {/*                 borderRadius: '5px',*/}
                {/*             }}>*/}
                {/*            <Image*/}
                {/*                src={Textura_App_Img}*/}
                {/*                preview={false}*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*    </Col>*/}
                {/*    <Col span={10} lg={{span: 10, offset: 1}} xs={{...MWidth}}>*/}
                {/*        <div className="vertical-center-text" style={{margin: '0 0 0 0'}}>*/}
                {/*            <h2 className="title-app" style={{*/}
                {/*                color: 'black',*/}
                {/*                ...TitleFont*/}
                {/*            }}>*/}
                {/*                Smart Screen for Your Smart Home.*/}
                {/*            </h2>*/}
                {/*            <p className="text-content-app" style={{*/}
                {/*                color: 'black',*/}
                {/*                fontFamily: "Proxima Nova, sans-serif",*/}
                {/*                fontWeight: '500',*/}
                {/*            }}>*/}
                {/*                {TEXTURA_TEXT["Smart Screen for Your Smart Home"]}*/}
                {/*            </p>*/}
                {/*            <Row>*/}
                {/*                <button type="submit"*/}
                {/*                        className={"pay-button"}*/}
                {/*                        onClick={() => {*/}
                {/*                            window.location.href = 'https://apps.apple.com/gb/app/vieunite/id1644381065'*/}
                {/*                        }}*/}
                {/*                        style={{*/}
                {/*                            marginTop: '1em', fontFamily: "Proxima Nova, sans-serif",*/}
                {/*                            fontWeight: '800',*/}
                {/*                            borderRadius: "10px",*/}
                {/*                            padding: '1em 0 1em 0',*/}
                {/*                        }}*/}

                {/*                >*/}
                {/*                    IOS APP STORE*/}
                {/*                </button>*/}
                {/*            </Row>*/}
                {/*            <Row>*/}
                {/*                <button type="submit"*/}
                {/*                        className={"pay-button"}*/}
                {/*                        onClick={() => {*/}
                {/*                            window.location.href = 'https://play.google.com/store/apps/details?id=com.app.vieunite&gl=GB'*/}
                {/*                        }}*/}
                {/*                        style={{*/}
                {/*                            marginTop: '1em', fontFamily: "Proxima Nova, sans-serif",*/}
                {/*                            fontWeight: '800', borderRadius: "10px",*/}
                {/*                            padding: '1em 0 1em 0',*/}
                {/*                        }}*/}
                {/*                >*/}
                {/*                    GOOGLE PLAY STORE*/}
                {/*                </button>*/}
                {/*            </Row>*/}
                {/*        </div>*/}
                {/*    </Col>*/}
                {/*</Row>*/}


                {/*Four Intro Cols*/}
                {/*<Row justify={"space-evenly"}*/}
                {/*     style={{*/}
                {/*         backgroundColor: '#f4f4f4',*/}
                {/*         flexWrap: 'wrap'*/}
                {/*     }}*/}
                {/*     className={"img-text-zone"}*/}
                {/*>*/}
                {/*    <Col span={9} lg={4} xs={{...MWidth / 2}}>*/}
                {/*        <div className="text-container ">*/}
                {/*            <h2 className="title-app primary-font" style={{*/}
                {/*                color: 'black',*/}
                {/*                display: "flex",*/}
                {/*                justifyContent: "center",*/}
                {/*                fontSize: '25px',*/}
                {/*            }}>*/}
                {/*                Simplicity*/}
                {/*            </h2>*/}
                {/*            <p className="text-content-app primary-font m-small-txt" style={{*/}
                {/*                color: 'black',*/}
                {/*                textAlign: "center", fontSize: '17px',*/}
                {/*            }}>*/}
                {/*                {TEXTURA_TEXT["Simplicity"]}*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </Col>*/}
                {/*    <Col span={8} lg={4} xs={{...MWidth / 2}}>*/}
                {/*        <div className="text-container ">*/}
                {/*            <h2 className="title-app" style={{*/}
                {/*                color: 'black',*/}
                {/*                display: "flex",*/}
                {/*                justifyContent: "center",*/}
                {/*                fontSize: '25px',*/}
                {/*            }}>*/}
                {/*                Accuracy*/}
                {/*            </h2>*/}
                {/*            <p className="text-content-app m-small-txt" style={{*/}
                {/*                color: 'black',*/}
                {/*                textAlign: "center",*/}
                {/*                fontSize: '17px',*/}
                {/*            }}>*/}
                {/*                {TEXTURA_TEXT["Accuracy"]}*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </Col>*/}
                {/*    <Col span={9} lg={4} xs={{...MWidth / 2}}>*/}
                {/*        <div className="text-container ">*/}
                {/*            <h2 className="title-app" style={{*/}
                {/*                color: 'black',*/}
                {/*                display: "flex",*/}
                {/*                justifyContent: "center",*/}
                {/*                fontSize: '25px',*/}
                {/*            }}>*/}
                {/*                Efficiency*/}
                {/*            </h2>*/}
                {/*            <p className="text-content-app m-small-txt" style={{*/}
                {/*                color: 'black',*/}
                {/*                textAlign: "center",*/}
                {/*                fontSize: '17px',*/}
                {/*            }}>*/}
                {/*                {TEXTURA_TEXT["Efficiency"]}*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </Col>*/}
                {/*    <Col span={8} lg={4} xs={{...MWidth / 2}}>*/}
                {/*        <div className="text-container ">*/}
                {/*            <h2 className="title-app" style={{*/}
                {/*                color: 'black',*/}
                {/*                display: "flex",*/}
                {/*                justifyContent: "center",*/}
                {/*                fontSize: '25px',*/}
                {/*            }}>*/}
                {/*                Transparency*/}
                {/*            </h2>*/}
                {/*            <p className="text-content-app m-small-txt" style={{*/}
                {/*                color: 'black',*/}
                {/*                textAlign: "center",*/}
                {/*                fontSize: '17px',*/}
                {/*            }}>*/}
                {/*                {TEXTURA_TEXT["Transparency"]}*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                { /* Product Reviews*/}
                <div>
                    <Row className={'m-img-art'} justify={'center'}
                         style={{padding: '5rem 0 1rem 0', background: '#f4f4f4'}}>
                        <Col span={10} lg={{span: 20}} xs={20}>
                            <h2 className="title-app mobile-left"
                                style={{textAlign: "left", ...TitleFont}}>
                                Product Reviews
                            </h2>
                        </Col>
                    </Row>
                    <Row
                        style={{background: '#f4f4f4', margin: "auto", width: windowWidth > 920 ? '82vw' : '84vw'}}>
                        <div className="digital-canvas-container-jack">
                            <div ref={sliderRef}
                                 className="digital-canvas-slider-jack"
                                 style={{
                                     transform: windowWidth > 920 ? `translateX(-${index * 29}vw)` : `translateX(-${index * 84}vw)`,
                                     touchAction: 'none' // Prevent default scroll on touch devices
                                 }}
                                 onTouchStart={handleDragStart}
                                 onTouchMove={handleDragMove}
                                 onTouchEnd={handleDragEnd}
                            >

                                <div className="digital-canvas-moving-div-Yang"
                                     onClick={() => window.open("https://www.techradar.com/home/smart-home/vieunite-textura-digital-canvas-review-a-digital-frame-on-steroids")}
                                     style={{cursor: 'pointer'}}>
                                    <div className="product-reviews-logo-yang">
                                        <RadarLogo/>
                                    </div>
                                    {/*<div className="product-reviews-stars-yang">*/}
                                    {/*    <img src={TexturaStars}/>*/}
                                    {/*</div>*/}
                                    <div className='product-reviews-text-yang'>“The Vieunite Textura Digital
                                        Canvas dwarfs standard digital photo frames for
                                        size
                                        and is next-level in almost every regard thanks to its ultra high-quality
                                        27-inch
                                        display . . . “
                                    </div>
                                </div>

                                <div className="digital-canvas-moving-div-Yang"
                                     onClick={() => window.open("https://www.independent.co.uk/extras/indybest/gadgets-tech/best-digital-photo-frames-b2295937.html#productId_42216")}
                                     style={{cursor: 'pointer'}}>
                                    <div className="product-reviews-logo-yang">
                                        <IndeLogo/>
                                    </div>
                                    {/*<div className="product-reviews-stars-Jack">*/}
                                    {/*    <img src={TexturaStars}/>*/}
                                    {/*</div>*/}
                                    <div className='product-reviews-text-yang'>“We love that this frame gives
                                        us
                                        the ultimate flexibility in what we display on
                                        our wall . . .”
                                    </div>
                                </div>

                                <div className="digital-canvas-moving-div-Yang"
                                     onClick={() =>
                                         window.open("https://www.creativebloq.com/reviews/vieunite-textura-digital-canvas")}
                                     style={{cursor: 'pointer'}}>
                                    <div className="product-reviews-logo-yang">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="207" height="43"
                                             viewBox="0 0 207 43" fill="none">
                                            <g clip-path="url(#clip0_302_118)">
                                                <path
                                                    d="M36.0671 40.07H5.09861C0.310375 40.07 0.207031 35.4666 0.207031 35.2225V5.02135C0.207031 0.278451 4.75414 0.278451 4.99527 0.173828H34.6892C39.3741 0.173828 39.3741 4.77723 39.3741 5.02135V36.7221L41.9233 39.3028L38.6507 42.5112L36.2049 40.0351H36.0671V40.07Z"
                                                    fill="#E94E1B"/>
                                                <path
                                                    d="M34.6889 0.523114C39.0293 0.523114 39.1327 4.81265 39.1327 5.0219V36.8273L39.236 37.0365L41.5784 39.1987L38.6159 42.1979L36.4802 39.9311L36.2735 39.7218H4.99492C0.654507 39.7218 0.551164 35.4323 0.551164 35.223V5.0219C0.551164 0.627737 4.78824 0.523114 4.99492 0.523114H34.6889ZM34.6889 0H4.99492C4.99492 0 0 0 0 5.05677V35.2579C0 35.2579 0 40.3147 4.99492 40.3147H36.0668L38.6159 43L42.3363 39.3382L39.6838 36.6529V5.05677C39.6838 5.05677 39.6838 0 34.6889 0Z"
                                                    fill="#E3441B"/>
                                                <path
                                                    d="M19.5315 27.8304V21.4832H14.8466V27.1678C14.8466 27.6909 14.6399 28.0396 13.9854 28.0396H13.4687C12.8486 28.0396 12.6075 27.7257 12.6075 27.1678V12.8693C12.6075 12.3462 12.8142 12.1021 13.4687 12.1021H13.9854C14.5021 12.1021 14.8466 12.4159 14.8466 12.8693V17.9261H19.3937V12.4508C19.3937 9.45161 18.0158 8.05664 15.1566 8.05664H12.2974C9.43828 8.05664 7.95703 9.45161 7.95703 12.3462V27.935C7.95703 30.8295 9.43828 32.2245 12.2974 32.2245H15.1911C18.0502 32.2245 19.5315 30.8295 19.5315 27.935M27.9023 27.1678C27.9023 27.6909 27.5923 28.0396 27.0411 28.0396H25.8699V21.9017H26.9377C27.5578 21.9017 27.9023 22.2156 27.9023 22.7736V27.1678ZM27.9023 17.0891C27.9023 17.6122 27.5923 17.9609 26.9377 17.9609H25.8699V12.2764H26.9377C27.5578 12.2764 27.7989 12.5903 27.7989 13.1483V17.124L27.9023 17.0891ZM32.5872 27.6211V22.7736C32.5872 21.0648 31.9671 20.0883 30.5548 19.6698C31.8293 19.3559 32.5872 18.2748 32.5872 16.1126V12.5554C32.5872 9.55623 31.1059 8.05664 28.1434 8.05664H21.2539V32.2245H28.3501C31.3126 32.2245 32.6905 30.7249 32.6905 27.7257"
                                                    fill="white"/>
                                                <path
                                                    d="M19.5315 27.8304V21.4832H14.8466V27.1678C14.8466 27.6909 14.6399 28.0396 13.9854 28.0396H13.4687C12.8486 28.0396 12.6075 27.7257 12.6075 27.1678V12.8693C12.6075 12.3462 12.8142 12.1021 13.4687 12.1021H13.9854C14.5021 12.1021 14.8466 12.4159 14.8466 12.9739V17.9261H19.3937V12.4508C19.3937 9.55624 18.0158 8.05664 15.1566 8.05664H12.2974C9.43828 8.05664 7.95703 9.55624 7.95703 12.3462V27.935C7.95703 30.8296 9.43828 32.2245 12.2974 32.2245H15.1911C18.0502 32.2245 19.5315 30.8296 19.5315 27.935M32.5872 27.6211V22.7736C32.5872 21.0648 31.9671 20.0883 30.5548 19.6698C31.8293 19.3559 32.5872 18.2748 32.5872 16.1126V12.5554C32.5872 9.55623 31.1059 8.05664 28.1434 8.05664H21.2539V32.2245H28.3501C31.3126 32.2245 32.6905 30.7249 32.6905 27.7257M27.9023 27.1678C27.9023 27.6909 27.5923 28.0396 27.0411 28.0396H25.8699V21.9017H26.9377C27.5578 21.9017 27.9023 22.2156 27.9023 22.7736V27.1678ZM27.9023 17.0891C27.9023 17.6122 27.5923 17.9609 26.9377 17.9609H25.8699V12.2764H26.9377C27.5578 12.2764 27.7989 12.5903 27.7989 13.1483V17.124L27.9023 17.0891Z"
                                                    stroke="#DD4531" stroke-width="1.81" stroke-miterlimit="10"/>
                                                <path
                                                    d="M59.1119 27.063V20.7159H54.427V26.6097C54.427 27.1328 54.117 27.4815 53.5658 27.4815H52.9458C52.3257 27.4815 52.0846 27.1677 52.0846 26.6097V12.102C52.0846 11.5789 52.2913 11.2301 52.9458 11.2301H53.4625C53.9792 11.2301 54.3237 11.544 54.3237 12.102V17.1587H59.0086V11.5789C59.0086 8.57967 57.5273 7.1847 54.5648 7.1847H51.809C48.8465 7.1847 47.3652 8.57967 47.3652 11.5789V27.063C47.3652 30.0622 48.8465 31.4572 51.7057 31.5618H54.6682C57.6307 31.5967 59.1119 30.0622 59.1119 27.063ZM68.964 17.4029C68.964 17.926 68.7573 18.1701 68.2061 18.1701H67.0349V11.6137H68.1028C68.7228 11.6137 69.0673 11.9276 69.0673 12.381V17.2982L68.964 17.4029ZM68.964 31.3526H73.7522V23.0874C73.7522 21.3785 73.2355 20.4021 71.7198 19.9836C72.9944 19.5651 73.8556 18.484 73.8556 16.4264V11.823C73.7522 8.82379 72.1676 7.53344 69.3085 7.53344H62.2122V31.4921H67.0005V22.355H68.0683C68.6884 22.355 69.0329 22.6689 69.0329 23.2269V31.4921L68.964 31.3526ZM77.0248 31.3526H85.9467V27.063H81.7096V21.2739H85.6367V16.9844H81.813V11.6137H85.8434V7.3242H77.0248V31.3526ZM95.4888 23.6454H93.3874L94.4209 13.1133L95.4888 23.6454ZM96.2466 31.3526H101.035L97.8656 7.39395H91.4928L88.3236 31.3526H92.5607L92.9741 27.7954H95.9366C95.9366 27.8303 96.2466 31.3526 96.2466 31.3526ZM109.406 11.6137H112.265V7.3242H101.862V11.6137H104.721V31.3875H109.509V11.6137H109.406ZM115.124 31.3526H119.912V7.39395H115.124V31.3526ZM132.003 31.3526L135.173 7.39395H130.729L129.041 24.2731L127.353 7.39395H122.565L125.734 31.3526H132.003ZM137.825 31.3526H146.644V27.063H142.51V21.2739H146.437V16.9844H142.51V11.6137H146.644V7.3242H137.928V31.3875H137.825V31.3526ZM161.077 26.4353C161.077 26.9584 160.767 27.3072 160.216 27.3072H159.148V21.1693H160.319C160.836 21.1693 161.181 21.4832 161.181 22.0411V26.3307L161.077 26.4353ZM161.077 16.3218C161.077 16.8449 160.767 17.1936 160.113 17.1936H159.045V11.5091H160.113C160.733 11.5091 160.974 11.823 160.974 12.381V16.3566H161.077V16.3218ZM165.728 26.8538V22.0063C165.728 20.2974 165.211 19.321 163.695 18.9025C164.97 18.484 165.728 17.4029 165.728 15.3453V11.7881C165.728 8.78892 164.246 7.39395 161.284 7.39395H154.291V31.3526H161.387C164.35 31.3526 165.728 29.853 165.728 26.8538ZM168.931 31.3526H177.095V27.063H173.685V7.53344H168.897V31.4921V31.3526H168.931ZM186.327 26.7492C186.327 27.7257 185.363 27.7257 185.363 27.7257H184.605C183.537 27.7257 183.537 26.6446 183.537 26.6446V12.1369C183.537 11.0557 184.605 11.0557 184.605 11.0557H185.363C186.431 11.0557 186.431 12.1369 186.431 12.1369V26.8538L186.327 26.7492ZM190.875 27.8303V10.8465C190.875 10.8465 190.875 7.08008 187.154 7.08008H182.917C182.917 7.08008 179.093 7.08008 179.093 10.8465V27.5862C179.093 27.5862 179.093 31.3526 182.814 31.4572H187.051C187.051 31.4572 190.875 31.4572 190.875 27.5862M200.417 26.5399C200.417 27.621 199.555 27.621 199.555 27.621H198.694C197.73 27.621 197.73 26.5399 197.73 26.5399V12.1369C197.73 11.0557 198.798 11.0557 198.798 11.0557H199.555C200.52 11.0557 200.52 12.1369 200.52 12.1369V26.8538L200.417 26.5399ZM206.686 30.8295L205.102 29.2253V10.9511C205.102 10.9511 205.102 7.08008 201.278 7.08008H197.041C197.041 7.08008 193.217 7.08008 193.217 10.8465V27.5862C193.217 27.5862 193.217 31.3526 196.937 31.4572H202.862L204.447 33.0614L206.583 30.7946H206.686V30.8295Z"
                                                    fill="url(#paint0_linear_302_118)"/>
                                            </g>
                                            <defs>
                                                <linearGradient id="paint0_linear_302_118" x1="47.3647" y1="20.0706"
                                                                x2="206.686" y2="20.0706"
                                                                gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#3C3C3C"/>
                                                    <stop offset="1" stop-color="#382E30"/>
                                                </linearGradient>
                                                <clipPath id="clip0_302_118">
                                                    <rect width="207" height="43" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>

                                    {/*<div className="product-reviews-stars-yang">*/}
                                    {/*    <img src={TexturaStars}/>*/}
                                    {/*</div>*/}

                                    <div className='product-reviews-text-yang'>“The Vieunite Textura Digital
                                        Canvas not only looks good and has a beautiful
                                        screen,
                                        but it becomes a portal to a new world of artists, right there in your home.
                                        . . . “
                                    </div>
                                </div>

                                <div className="digital-canvas-moving-div-Yang"
                                     onClick={() => window.open("https://www.t3.com/reviews/vieunite-textura-digital-canvas-review-iconic-artwork-at-the-touch-of-a-button")}
                                     style={{cursor: 'pointer'}}>
                                    <div className="product-reviews-logo-yang">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="62" height="38"
                                             viewBox="0 0 62 38" fill="none">
                                            <path
                                                d="M61.8537 17.3046C62.8861 11.7215 58.5354 9.35385 46.2502 9.35385C43.743 9.35385 41.516 9.45615 39.4955 9.70461L41.2358 0H0V10.8154H11.6953L6.85788 38H20.7801L25.6323 10.8154H34.4516C30.8531 12.0723 28.4934 14.1769 27.638 17.5531H39.584C40.4984 16.3985 41.0588 16.0915 44.9081 16.0915C49.3325 16.0915 49.8782 17.1146 49.6717 18.3131C49.4947 19.3362 48.7721 20.2131 46.2207 20.2131L40.1592 20.2277L38.9793 26.7315H44.5394C47.43 26.7315 48.8753 27.2285 48.5804 28.9823C48.3296 30.2977 47.4595 31.7008 42.2387 31.7008C39.8937 31.7008 38.3599 31.4962 37.475 30.9554C36.5901 30.4438 36.2509 29.6838 36.3394 28.6754H24.6294C23.9805 34.5508 27.3725 36.9915 32.1214 38H50.1142C56.9721 36.6554 59.8332 33.4838 60.5264 29.5377C61.1458 25.9715 59.3465 23.8377 55.9544 23.0485V22.9462C60.3494 21.9962 61.485 19.5846 61.8537 17.3046Z"
                                                fill="black"/>
                                        </svg>
                                    </div>

                                    {/*<div className="product-reviews-stars-Jack">*/}
                                    {/*    <img style={{objectFit: "none"}}*/}
                                    {/*         src={TexturaStars1}></img>*/}
                                    {/*</div>*/}

                                    <div className='product-reviews-text-yang'>“If you're looking for a
                                        digital
                                        frame that showcases iconic pieces of art as
                                        well as your own photos, then the Vieunite Textura Digital Canvas is one of
                                        the
                                        best choices out there. . . . “
                                    </div>
                                </div>

                                <div className="digital-canvas-moving-div-Yang"
                                     onClick={() => window.open("https://www.wired.com/gallery/best-digital-picture-frames#662a9a7ff63289be6b2edb61")}
                                     style={{cursor: 'pointer'}}>
                                    <div className="product-reviews-logo-yang">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="203" height="41"
                                             viewBox="0 0 203 41" fill="none">
                                            <path
                                                d="M171.269 6.3708V34.7311H185.1C188.965 34.7311 191.202 34.1146 192.83 32.676C194.864 30.8265 195.881 27.5383 195.881 20.551C195.881 13.5636 194.864 10.2755 192.83 8.4259C191.202 6.98733 188.965 6.3708 185.1 6.3708H171.269ZM190.185 20.551C190.185 26.7163 189.779 28.1548 188.558 28.9769C187.744 29.5934 186.727 29.7989 184.693 29.7989H176.964V11.0975H184.693C186.727 11.0975 187.744 11.0975 188.558 11.9196C189.779 12.9471 190.185 14.3857 190.185 20.551ZM203 41H162.42V0H203V41ZM129.266 11.0975V6.3708H153.268V15.4132H148.181V11.0975H138.418V17.8793H146.147V22.4006H138.418V30.0044H148.386V25.0722H153.47V34.7311H129.267V30.0044H133.131V11.0975H129.266ZM107.501 27.3328C107.501 30.4154 107.703 32.676 108.11 34.5256H113.604C113.398 33.0871 113.197 30.4154 113.197 26.9218C112.992 22.8116 111.771 22.195 108.924 21.5785C112.178 20.962 113.604 19.5234 113.604 14.3857C113.604 10.2755 112.992 8.63141 111.771 7.60386C110.958 6.78182 109.535 6.3708 107.296 6.3708H90.2101V34.7311H95.9055V23.6336H103.84C105.467 23.6336 106.076 23.8391 106.688 24.2501C107.3 24.6612 107.501 25.2777 107.501 27.3328ZM95.9055 19.1124V11.303H105.06C106.281 11.303 106.688 11.5085 106.889 11.7141C107.296 12.1251 107.703 12.7416 107.703 15.2077C107.703 17.6738 107.296 18.4959 106.889 18.9069C106.688 19.1124 106.281 19.3179 105.06 19.3179L95.9055 19.1124ZM121.74 41H81.0584V0H121.637V41H121.74ZM70.4813 30.0044V34.7311H51.156V30.0044H58.0718V11.0975H51.156V6.3708H70.4796V11.0975H63.5638V30.0044H70.4813ZM37.8337 6.3708H32.5451L28.6804 28.7714L24.2054 8.01488C24.002 6.57631 23.3918 6.3708 22.1713 6.3708H19.3236C18.1032 6.3708 17.493 6.78182 17.2896 8.01488L12.8146 28.7714L8.9499 6.3708H3.25451L8.74649 33.2926C8.9499 34.5256 9.35671 34.7311 10.7806 34.7311H14.6453C15.8657 34.7311 16.2725 34.5256 16.6794 33.2926L20.9509 13.7691L25.2224 33.2926C25.4259 34.5256 25.8327 34.7311 27.2565 34.7311H30.9178C32.1383 34.7311 32.7485 34.5256 32.9519 33.2926L37.8337 6.3708ZM40.6814 41H0V0H40.5805V41H40.6814Z"
                                                fill="black"/>
                                        </svg>
                                    </div>
                                    <div className='product-reviews-text-yang'>“Vieunite's Textura Digital
                                        Canvas
                                        is beautiful for displaying professional art.
                                        It's bright and high-def enough that you don't lose the integrity of the
                                        original painting. . . . “
                                    </div>
                                </div>

                                <div className="digital-canvas-moving-div-Yang"
                                     onClick={() => window.open("https://www.gq-magazine.co.uk/")}
                                     style={{cursor: 'pointer'}}>
                                    <div className="product-reviews-logo-yang">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="153" height="82"
                                             viewBox="0 0 153 82" fill="none">
                                            <path
                                                d="M141.945 64.9916C141.945 64.9916 149.428 55.0987 149.454 42.1903C149.506 16.8497 132.011 0.396814 107.632 0.370363C93.5 0.343911 81.5061 7.32713 74.2316 17.5639C73.9709 17.1936 73.7101 16.8497 73.4494 16.4794C67.3742 8.30584 56.8666 0.0264919 40.5706 4.02514e-05C21.4064 -0.0264113 6.59663 12.9878 1.72086 28.8852C1.66871 29.0703 1.61656 29.282 1.56442 29.4671V29.4936C0.547546 33.0645 0 36.8207 0 40.709C0.0260736 44.4123 0.521472 47.9832 1.3819 51.3426C4.45859 62.9548 12.4632 72.5303 23.023 77.6884C23.1012 77.7148 23.1794 77.7677 23.2837 77.8206C23.3359 77.8471 23.388 77.8736 23.4402 77.9C28.7592 80.36 34.7301 81.7355 41.092 81.7619C54.546 81.6561 66.4617 74.9639 73.8144 64.7271C73.9709 64.5155 74.1012 64.3039 74.2577 64.0923C81.3497 74.4613 93.135 82 107.762 82C117.462 82 124.319 77.7942 125.571 77.1329L128.152 80.5716H153L141.945 64.9916ZM40.8574 59.2781C32.1748 59.2781 22.319 52.3213 22.1365 41.1587C21.9279 29.5994 31.7837 22.0342 40.8574 22.3516C48.2362 22.6162 51.0521 24.7587 55.1457 28.8587C55.1457 28.8587 61.0905 28.8587 67.1396 28.8587C67.6089 28.8587 68.0521 28.8587 68.5215 28.8587C68.5215 28.8587 68.5215 28.8587 68.5215 28.8852C67.9479 30.6839 67.5046 32.5091 67.1917 34.3607H43.7515V53.591H54.0245C54.0245 54.0936 48.7577 59.2781 40.8574 59.2781ZM126.822 46.5284L124.71 43.6187H99.4969L109.744 58.6432C99.0798 60.7594 88.9893 51.7129 89.1457 41.1852C89.3021 30.4194 97.8543 22.3781 108.101 22.431C119.339 22.5104 130.525 34.7839 126.822 46.5284Z"
                                                fill="black"/>
                                        </svg>
                                    </div>
                                    <div className='product-reviews-text-yang'>“This digital canvas is like a
                                        digital photo frame on steroids. . . . “
                                    </div>
                                </div>

                                <div className="digital-canvas-moving-div-Yang"
                                     onClick={() => window.open("https://www.digitalcameraworld.com/reviews/vieunite-textura-review")}
                                     style={{cursor: 'pointer'}}>
                                    <div className="product-reviews-logo-yang">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="166" height="62"
                                             viewBox="0 0 166 62" fill="none">
                                            <path
                                                d="M75.5683 14.5522V0H72.9086V14.5522H75.5683ZM69.3101 12.5396L68.0584 12.6944C66.4939 12.6944 66.0245 12.3848 66.0245 11.3012C66.0245 10.2175 66.3374 9.75305 68.0584 9.75305H69.4665V12.3848L69.3101 12.5396ZM71.9698 14.3974V7.12127C71.9698 4.64431 70.4053 3.56064 67.7455 3.56064C66.5382 3.53512 65.3317 3.63893 64.147 3.87026V5.88279H64.6164L67.7455 5.57317C68.8407 5.57317 69.3101 5.88279 69.3101 7.12127V8.05013H68.0584C64.6164 8.05013 63.3647 9.13381 63.3647 11.3012C63.3647 13.6233 64.9293 14.707 68.0584 14.707L71.9698 14.3974ZM63.2083 14.3974V12.6944H61.6437C61.0179 12.6944 61.0179 12.5396 61.0179 11.6108V5.41836H63.2083V3.87026H61.0179V1.23848L58.3582 1.70291V3.71545H56.3242V5.26355H56.7936L58.5146 5.57317V11.6108C58.5146 14.0877 59.4533 14.707 61.6437 14.707L63.0518 14.5522H63.3647M55.5419 14.5522V3.71545H52.8822V14.3974H55.3855L55.5419 14.5522ZM55.5419 2.47696V0H52.8822V2.47696H55.5419ZM41.4609 14.0877V3.71545H38.9576V14.5522H41.4609V13.9329V14.0877ZM41.4609 2.16734V0H38.9576V2.47696H41.6173V2.16734H41.4609ZM35.5156 8.82419C35.5156 11.6108 33.951 12.3848 32.0735 12.3848H30.509V2.32215H32.0735C33.951 2.32215 35.5156 3.09621 35.5156 5.88279V8.82419ZM38.1753 8.82419V5.88279C38.1753 2.16734 35.9849 0 31.9171 0C30.5037 0.0131917 29.0927 0.116613 27.6927 0.309621V14.2425L28.1621 14.3974L32.0735 14.707C35.9849 14.707 38.1753 12.5396 38.1753 8.82419ZM141.28 22.1379V15.3262H140.028C137.838 15.3262 134.709 15.7906 131.893 17.958V15.6358H124.696V47.5268H132.205V24.6148C133.457 23.0667 141.28 22.1379 141.28 22.1379ZM115.308 28.7947H103.261V28.6399C103.261 24.1504 105.764 21.6734 109.363 21.6734C112.805 21.6734 115.308 24.1504 115.308 28.6399V28.7947ZM122.975 32.9746V29.414C122.975 21.0542 118.124 15.0166 109.363 15.0166C100.601 15.0166 95.4383 20.7446 95.4383 29.5688V33.7486C95.4383 44.895 103.574 47.9912 109.363 47.9912C113.466 48.0672 117.564 47.6513 121.566 46.7527V40.8699H120.471C118.124 41.1795 114.213 41.4892 109.989 41.4892C104.513 41.4892 103.105 37.6189 103.105 34.3679V34.0583H121.879C122.505 34.0583 122.975 33.5938 122.975 32.8198M93.7172 26.937C93.7172 20.2801 92.1527 15.0166 84.3299 15.0166C80.262 15.0166 77.7587 16.1003 74.9425 17.6484C73.5344 16.1003 71.344 15.0166 68.2149 15.0166C64.7729 15.0166 62.426 16.2551 60.0792 17.8032V15.481H52.7257V47.3719H60.2356V23.5312C61.8892 22.497 63.7646 21.8608 65.7116 21.6734C68.8407 21.6734 69.623 22.7571 69.623 27.0918V47.5268H77.1329V27.0918L76.9764 23.0667C78.6103 22.1637 80.4281 21.6347 82.2959 21.5186C85.4251 21.5186 86.3638 22.7571 86.3638 27.0918V47.5268H93.8737V27.0918L93.7172 26.937ZM43.1819 42.1084H39.2705C34.5768 42.1084 33.3252 41.3343 33.3252 38.2381V37.7737C33.3252 34.6775 33.951 33.2842 39.2705 33.2842H43.1819V42.1084ZM50.6918 25.8533C50.6918 18.5772 46.311 15.0166 38.1753 15.0166C34.2639 15.0166 30.9783 15.481 28.7879 15.9455L27.5363 16.2551V21.8282H28.9444C30.8219 21.5186 34.5768 21.3638 38.3318 21.3638C41.4609 21.3638 43.1819 22.1379 43.1819 26.0081V28.3303H39.2705C29.2573 28.3303 25.8153 31.5813 25.8153 38.0833V38.2381C25.8153 45.0498 29.8831 47.8364 39.2705 47.8364C44.59 47.8364 50.6918 47.3719 50.6918 47.3719V26.0081V25.8533ZM27.2234 46.4431C24.4072 43.9661 24.2507 40.7151 24.0942 40.7151C21.4918 40.9208 18.8822 41.0241 16.2714 41.0247C11.5778 41.0247 7.97926 38.3929 7.97926 30.4976V23.686C7.97926 15.7906 11.4213 13.1589 16.2714 13.1589C19.557 13.0041 26.4411 13.9329 26.4411 13.9329V7.74051L25.1894 7.43089C24.2507 7.12127 20.4958 6.50203 16.115 6.50203C9.38737 6.65684 0 9.75305 0 23.8408V30.6524C0 44.5854 9.38737 47.9912 16.115 47.9912C19.1631 47.9739 22.2023 47.6628 25.1894 47.0623L27.2234 46.5979M148.633 37.9285C148.633 34.8323 149.416 33.439 154.579 33.439H158.49V42.2632H154.579C149.885 42.2632 148.633 41.4892 148.633 38.3929M166 26.0081C166 18.732 161.619 15.1714 153.484 15.1714C149.572 15.1714 146.287 15.481 144.096 15.9455L143.001 16.2551V21.9831C143.001 21.9831 147.538 21.3638 153.484 21.3638C156.926 21.3638 158.49 22.2927 158.49 26.0081V28.4851H154.579C144.566 28.4851 141.123 31.7361 141.123 38.2381V38.3929C141.123 45.2046 145.191 47.9912 154.579 47.9912C159.898 47.9912 166 47.5268 166 47.5268V26.0081Z"
                                                fill="#333333"/>
                                            <path
                                                d="M49.049 15.7234C49.049 16.3404 48.7357 16.6489 46.8559 16.6489C44.9762 16.6489 44.5063 16.1862 44.5063 15.4149V15.2606C44.5063 14.6436 44.6629 14.3351 44.9762 13.8723L46.6993 14.3351C48.7357 14.7979 49.049 15.1064 49.049 15.4149V15.5691V15.7234ZM48.7357 7.70213C48.7357 8.62766 48.2657 9.24468 46.6993 9.24468C44.9762 9.24468 44.6629 8.31915 44.6629 7.70213V7.54787C44.6629 6.62234 44.9762 5.85106 46.6993 5.85106C48.2657 5.85106 48.7357 6.62234 48.7357 7.39362V7.70213ZM51.8685 5.54255V4H46.6993C43.4098 4 42 5.54255 42 7.39362V7.54787C42 8.4734 42.3133 9.09043 42.9399 9.8617C42.3133 10.1702 42.1566 10.7872 42.1566 11.4043C42.1566 12.0213 42.4699 12.7926 42.9399 13.1011C42.3496 13.6707 42.0118 14.4469 42 15.2606V15.4149C42 17.4202 43.5664 18.5 46.6993 18.5C50.1455 18.5 51.5552 17.5745 51.5552 15.5691C51.5552 13.4096 49.9888 12.9468 47.1692 12.484L44.9762 11.867C44.5063 11.867 44.193 11.5585 44.193 11.25L44.6629 10.7872C44.9762 10.7872 45.6028 11.0957 46.6993 11.0957C49.6755 11.0957 51.3986 10.016 51.3986 7.54787C51.3986 6.7766 51.0853 6.31383 50.772 6.00532L51.3986 5.69681L51.7119 5.54255M139.276 49.8138H136.926L135.673 58.1436H135.516L133.793 49.8138H130.66L128.937 58.1436L127.371 49.8138H124.708C125.336 53.8759 126.226 57.8946 127.371 61.8457H129.877L131.757 53.516L133.636 61.8457H136.613C137.709 57.8351 138.492 53.8245 139.276 49.8138ZM144.915 57.5266C144.915 59.5319 144.445 60.3032 143.348 60.3032C142.252 60.3032 141.782 59.5319 141.782 57.0638C141.782 55.0585 142.252 54.2872 143.348 54.2872C144.445 54.2872 144.915 55.0585 144.915 57.5266ZM147.734 57.0638C147.734 53.9787 146.481 52.4362 143.505 52.4362C140.372 52.4362 138.806 54.2872 138.806 57.5266C138.806 60.6117 140.372 62 143.192 62C146.324 62 147.891 60.4574 147.891 57.0638M154 52.7447C152.59 52.4362 151.964 52.5904 150.867 54.2872V52.7447H148.517V61.8457H151.18V57.0638C151.18 55.2128 152.434 54.75 153.687 55.2128L154 52.7447Z"
                                                fill="#333333"/>
                                            <path
                                                d="M154 49H156.757V61.8415H154V49ZM163.243 58.3537C163.243 59.1463 162.595 59.939 161.622 59.939C160.811 59.939 160.324 59.1463 160.324 57.0854C160.324 54.8659 161.135 54.0732 162.27 54.0732L163.243 54.2317V58.3537ZM166 61.8415V49H163.243V52.4878H162.432C158.865 52.4878 157.405 54.0732 157.405 57.7195C157.405 60.7317 158.378 62 160.649 62C161.946 62 162.919 61.3659 163.568 60.7317L163.73 61.8415H166Z"
                                                fill="#333333"/>
                                        </svg>
                                    </div>
                                    <div className='product-reviews-text-yang'>“This is an impressive digital
                                        photo frame that adds a real wow factor to your best images. . . .“
                                    </div>
                                </div>

                                <div className="digital-canvas-moving-div-Yang"
                                     onClick={() => window.open("https://www.ft.com/content/83ac4622-3ae5-4579-8ba5-5455858fe31f")}
                                     style={{cursor: 'pointer'}}>
                                    <div className="product-reviews-logo-yang">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="309" height="25"
                                             viewBox="0 0 309 25" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M7.41747 21.315C7.41747 23.0581 7.91545 23.4565 11.1014 23.4565V24.552H0V23.4565C2.19029 23.4565 2.93741 23.2571 2.93741 21.3649V3.58581C2.93741 1.69324 2.19029 1.49392 0 1.49392V0.398358H18.6186L18.7184 7.02191H17.8222C17.3242 2.04199 16.0797 1.59402 11.45 1.59402H7.36787V11.4546H10.6533C13.7897 11.4546 13.9889 10.9565 14.2378 8.46651H15.134V15.6877H14.2378C13.9889 13.1978 13.7897 12.7492 10.6533 12.7492H7.36787V21.3153H7.41776L7.41747 21.315ZM21.0082 24.552V23.4565C23.1988 23.4565 23.9456 23.2571 23.9456 21.3649V3.58581C23.9456 1.69324 23.1988 1.49392 21.0082 1.49392V0.398358H31.3631V1.49421C29.1725 1.49421 28.4256 1.69354 28.4256 3.58611V21.3652C28.4256 23.2574 29.1725 23.4568 31.3631 23.4568V24.5523H21.0079L21.0082 24.552ZM54.8603 24.9504L38.3324 4.48205V21.2654C38.3324 23.2078 39.6764 23.5064 41.9668 23.5064V24.6022H33.205V23.5064C35.4948 23.5064 36.7396 23.2078 36.7396 21.2654V2.63938C35.694 1.54382 34.9472 1.49392 33.205 1.49392V0.398358H40.9711L53.6158 16.6835V3.68533C53.6158 1.74315 52.2718 1.44431 49.9817 1.44431V0.398358H58.793V1.49421C56.5033 1.49421 55.2585 1.79305 55.2585 3.73553V24.951H54.8603V24.9504ZM66.6589 24.552H57.9467V23.4565C60.2368 23.4565 61.2824 23.1576 62.0289 21.1655L69.8947 0.149421H72.085L80.5481 21.315C81.2949 23.2075 81.6432 23.4066 83.3857 23.4066V24.5021H73.28V23.4066C76.3664 23.4066 76.6652 23.1576 75.918 21.315L73.4293 14.8907H65.8622L63.6223 21.1156C62.9254 23.0082 64.0205 23.4066 66.7088 23.4066V24.552H66.6589ZM66.3103 13.6455H72.8814L69.4466 4.98021L66.3103 13.6455ZM106.086 24.9504L89.6085 4.48205V21.2654C89.6085 23.2078 90.9525 23.5064 93.2426 23.5064V24.6022H84.6798V23.5064C86.7709 23.5064 88.0154 23.2078 88.0154 21.2654V2.68929C86.8208 1.59373 85.9246 1.49392 83.9336 1.49392V0.398358H92.197L104.842 16.6835V3.68533C104.842 1.74315 103.498 1.44431 101.208 1.44431V0.398358H109.97V1.49421C107.68 1.49421 106.435 1.79305 106.435 3.73553V24.951H106.086V24.9504ZM130.53 0.348747H131.127L131.476 7.56969L130.58 7.6196C129.982 3.4863 127.792 1.29488 123.759 1.29488C119.279 1.29488 115.894 5.12964 115.894 11.0061C115.894 18.5262 120.623 22.8089 125.601 22.8089C127.742 22.8089 129.683 22.2115 131.575 20.1698L132.272 20.8667C130.729 23.0581 127.692 24.9008 123.61 24.9008C117.536 24.9008 111.364 20.3189 111.364 12.6494C111.363 5.22915 116.989 0 123.809 0C127.045 0 128.738 1.3944 129.634 1.3944C130.032 1.3944 130.331 1.04595 130.53 0.348747ZM134.263 24.552V23.4565C136.454 23.4565 137.201 23.2571 137.201 21.3649V3.58581C137.201 1.69324 136.454 1.49392 134.263 1.49392V0.398358H144.618V1.49421C142.428 1.49421 141.681 1.69354 141.681 3.58611V21.3652C141.681 23.2574 142.428 23.4568 144.618 23.4568V24.5523L134.263 24.552ZM154.376 24.552H146.261V23.4565C148.053 23.4565 148.999 23.1576 149.746 21.1655L157.611 0.149421H159.802L168.265 21.315C169.012 23.2075 169.36 23.4066 171.102 23.4066V24.5021H160.997V23.4066C164.083 23.4066 164.382 23.1576 163.635 21.315L161.146 14.8907H153.579L151.339 21.1156C150.642 23.0082 151.737 23.4066 154.426 23.4066V24.552H154.376ZM154.027 13.6455H160.598L157.213 4.98021L154.027 13.6455ZM172.795 24.552V23.4565C174.986 23.4565 175.732 23.2571 175.732 21.3649V3.58581C175.732 1.69324 174.986 1.49392 172.795 1.49392V0.398358H183.1V1.49421C180.91 1.49421 180.212 1.69354 180.212 3.58611V21.5146C180.212 23.108 181.009 23.3073 182.304 23.3073H183.548C188.228 23.3073 189.721 22.6101 191.015 17.2815L191.912 17.381L191.165 24.5027H172.795V24.5526V24.552ZM222.976 0.398358L223.075 7.42027H222.179C221.682 2.24102 220.437 1.59402 215.807 1.59402H214.314V21.3153C214.314 23.2078 215.011 23.4568 217.998 23.4568V24.5523H206.149V23.4568C209.136 23.4568 209.883 23.1579 209.883 21.3153V1.59373H208.39C203.76 1.59373 202.515 2.24102 202.017 7.42027H201.121L201.221 0.398358H222.976ZM225.316 24.5523V23.4565C227.506 23.4565 228.253 23.2571 228.253 21.3649V3.58581C228.253 1.69324 227.506 1.49392 225.316 1.49392V0.398358H235.67V1.49421C233.48 1.49421 232.733 1.69354 232.733 3.58611V21.3652C232.733 23.2574 233.48 23.4568 235.67 23.4568V24.5523H225.316ZM266.835 0.398065V1.49421C264.644 1.49421 263.698 1.59402 263.897 3.5362L265.789 21.4647C265.988 23.3073 266.685 23.5064 268.875 23.5064V24.6022H258.57V23.5064C260.711 23.5064 261.458 23.3073 261.309 21.4647L259.367 2.63909L251.75 25H251.451L243.984 2.58977L242.191 21.4145C241.992 23.307 243.287 23.5061 245.477 23.5061V24.6019H237.412V23.5061C239.603 23.5061 240.35 23.1576 240.499 21.4145L242.391 3.486C242.59 1.59373 241.644 1.44431 239.453 1.44431V0.398358H247.916L252.994 16.8825L258.47 0.398358H266.834L266.835 0.398065ZM286.1 15.6872H285.204C284.955 13.1972 284.756 12.7486 281.62 12.7486H277.936V21.514C277.936 23.1074 278.732 23.3068 280.026 23.3068H282.018C286.697 23.3068 288.191 22.6096 289.485 17.2809L290.381 17.3804L289.535 24.5021H270.518V23.4063C272.708 23.4063 273.455 23.2072 273.455 21.3147V3.58581C273.455 1.69324 272.708 1.49392 270.518 1.49392V0.398358H288.788L288.888 6.42423H287.992C287.444 2.14121 286.349 1.64334 281.57 1.64334H277.986V11.4541H281.669C284.806 11.4541 285.005 10.9562 285.254 8.46622H286.15V15.6875H286.1L286.1 15.6872ZM305.316 19.5715C305.316 17.3804 303.922 16.2848 301.533 14.9401L297.7 12.948C294.812 11.4041 293.12 9.7109 293.12 6.67316C293.12 2.88861 296.355 0 300.587 0C303.474 0 304.968 1.3944 305.814 1.3944C306.362 1.3944 306.61 1.04595 306.859 0.348747H307.556L307.905 7.12172L307.009 7.17163C306.511 3.88436 304.171 1.3445 300.886 1.3445C298.396 1.3445 296.754 2.83871 296.754 4.93031C296.754 7.22124 298.496 8.16737 300.437 9.21332L303.723 10.9562C306.81 12.6494 309 14.3427 309 17.5797C309 21.8627 305.316 24.9008 300.736 24.9008C297.5 24.9008 295.907 23.3567 295.061 23.3567C294.513 23.3567 294.215 23.8548 293.966 24.6019H293.269L292.771 17.4303L293.667 17.3308C294.364 21.8128 297.451 23.6555 300.537 23.6555C303.126 23.6056 305.316 22.4604 305.316 19.5721L305.316 19.5715Z"
                                                  fill="#231F20"/>
                                        </svg>
                                    </div>
                                    <div className='product-reviews-text-yang'>“Digital photo frames are
                                        ten-a-penny, but sumptuous 27in digital canvases that bring the Old Masters
                                        into
                                        your living room aren’t . . .“
                                    </div>
                                </div>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: '20px'
                            }}
                                 className={'m-digi-arrows-yang'}
                            >
                                <img className={'m-no'} src={leftScroll} alt="Scroll Left" onClick={slideLeft}
                                     style={{cursor: 'pointer', width: '15.5px', height: '31px'}}/>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    {Array.from({length: totalLines}).map((_, idx) => (
                                        <div key={idx} style={{margin: '0 2px'}}>
                                            {activeLineIndex === idx ? <ScrollActive/> : <ScrollInactive/>}
                                        </div>))}
                                </div>
                                <img className={'m-no'} src={rightScroll} alt="Scroll Right" onClick={slideRight}
                                     style={{cursor: 'pointer', width: '15.5px', height: '31px'}}/>
                            </div>
                        </div>
                    </Row>
                </div>


                { /* Video Reviews*/}
                <Row className={'m-img-art'} justify={'center'}
                     style={{padding: '6rem 0 1rem 0', background: '#f4f4f4'}}>
                    <Col span={10} lg={{span: 20}} xs={20}>
                        <h2 className="title-app mobile-left"
                            style={{textAlign: "left", ...TitleFont}}>
                            Video Reviews
                        </h2>
                        <p className="text-content-app mobile-left artist-text"
                           style={{
                               ...PrimaryFont, fontWeight: '500', fontSize: '1rem', marginTop: '-1rem'
                           }}>
                            All video reviews featured are independent and have not been compensated by
                            Vieunite.
                        </p>
                    </Col>
                </Row>

                <Row justify={"center"}
                     style={{
                         backgroundColor: '#E7E7E7',
                         margin: "0 8vw 0 8vw",
                         borderRadius: "15px",
                         overflow: "hidden",
                         height: "auto"
                     }}
                >
                    <Col span={10} lg={10} xs={24}>
                        <div style={{
                            marginLeft: '10%', height: '100%', display: 'flex', flexDirection: 'column'
                        }}>
                            <div className='spacer' style={{minHeight: '40px'}}></div>
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center", // paddingBottom: '1rem',
                            }}>
                                <img src={YouTubeLogo}/>
                                <h2 className="title-app"
                                    style={{
                                        ...TitleFont,
                                        fontSize: '2rem',
                                        textAlign: 'left',
                                        lineHeight: 1,
                                        margin: "0 1rem"
                                    }}
                                >
                                    Tech Spurt
                                </h2>
                            </div>

                            <p className="text-content-app"
                               style={{width: '100%', marginRight: '2rem'}}>
                                Popular Tech Journalist and Youtube Star Chris Barraclough offers many in-depth
                                reviews, comparisons, unboxings and hands-on features with fresh new UK smartphones,
                                laptops, wearables, apps and other new gadgets. Watch his review for the Textura
                                Digital Canvas.
                            </p>
                            {/*<a className={'watch-full-video'} href={'https://youtu.be/8BgRHPt6vSE'}>*/}
                            {/*    Watch Full Video*/}
                            {/*</a>*/}
                            <a className={'watch-full-video'} href={'https://youtu.be/8BgRHPt6vSE'} target="_blank"
                               rel="noopener noreferrer">
                                Watch Full Video
                            </a>
                            <div className='spacer'></div>
                        </div>
                    </Col>

                    <Col span={14} lg={{span: 14}} xs={24}>
                        <div className="iframe-container">
                            <iframe width="672" height="378"
                                    src="https://www.youtube.com/embed/8BgRHPt6vSE?si=mSxdRVNJTknmb7kn"
                                    title="YouTube video player" frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                                    style={{margin: "4rem 2rem"}}
                            ></iframe>
                        </div>

                    </Col>
                </Row>


                {/*Google Reviews*/}
                <Row className={'m-img-art'} justify={'center'}
                     id={'REVIEWS'}
                     style={{padding: '5rem 0 1rem 0', background: '#f4f4f4'}}>
                    <Col span={10} lg={{span: 20}} xs={20}>
                        <h2 className="title-app mobile-left"
                            style={{textAlign: "left", ...TitleFont}}>
                            Customer Reviews
                        </h2>
                        <p className="text-content-app mobile-left artist-text"
                           style={{
                               ...PrimaryFont, fontWeight: '500', fontSize: '1rem', marginTop: '-1rem'
                           }}>
                            Read reviews of Vieunite on <a
                            href='https://www.google.com/search?gs_ssp=eJzj4tVP1zc0LLZMyU6vNC02YLRSNagwsTA3sDQ3T022MDA1MDYxtTKosDQ0TTFOTjGyTEu0NDVKsfDiKMtMLc3LLEkFADVZEi0&q=vieunite&rlz=1C5CHFA_enGB1000GB1000&oq=vieunite&aqs=chrome.1.69i60j46i175i199i512j35i39j0i512j69i60l4.3900j0j7&sourceid=chrome&ie=UTF-8'
                            style={{color: "black", textDecoration: "underline"}}>Google</a>.
                        </p>
                    </Col>
                </Row>
                <Row justify={"center"} align={"top"}
                     style={{background: '#f4f4f4', columnGap: '1rem', paddingBottom: '4rem'}}>
                    {/*Left part*/}
                    <Col span={20} lg={10} xs={{...MWidth}} style={{
                        backgroundColor: '#f4f4f4', // paddingBottom: '2.75rem',
                        // paddingTop: '2.75rem',
                    }}>
                        <Space direction={"vertical"} size={'large'}>
                            <ReviewCard reviewer={Reviews[0]}></ReviewCard>
                            <ReviewCard reviewer={Reviews[1]}></ReviewCard>
                            <ReviewCard reviewer={Reviews[2]}></ReviewCard>
                        </Space>
                    </Col>

                    {/*Right part*/}
                    <Col className={'right-review-card'} span={20} lg={10} xs={{...MWidth}} style={{
                        backgroundColor: '#f4f4f4',
                    }}>
                        <ReviewCard reviewer={Reviews[3]}></ReviewCard>
                    </Col>
                </Row>

                {/*Collapsable Sections*/}
                <Row justify={"center"}
                     style={{
                         backgroundColor: '#f4f4f4',
                     }}>
                    <Col span={20} lg={20} md={20}>
                        <Collapse expandIconPosition={"end"}
                                  bordered={false}
                                  style={{
                                      backgroundColor: '#f4f4f4', color: '#f4f4f4', border: "none"
                                  }}
                                  expandIcon={(panelProps) => {
                                      if (panelProps.isActive) {
                                          return <MinusOutlined style={{fontSize: '24px', fontWeight: "900"}}/>
                                      } else {
                                          return <PlusOutlined style={{fontSize: '24px', fontWeight: "900"}}/>
                                      }
                                  }}
                        >
                            <Panel header="Specification"
                                   className={'help-center-collapse-copy'}
                                   key="1">

                                <i className="specification-section-title">Physical Specification</i>
                                <br/>
                                <b className="specification-title">Display Size</b>
                                <p className="specification-body">27 Inches</p>
                                <b className="specification-title">Brightness</b>
                                <p className="specification-body">50 - 250 nits</p>
                                <b className="specification-title">Resolution</b>
                                <p className="specification-body">1920x1080</p>
                                <b className="specification-title">Speakers</b>
                                <p className="specification-body">1.5W, 8Ω (x2)</p>
                                <b className="specification-title">Canvas Orientation</b>
                                <p className="specification-body">Portrait/Landscape</p>
                                <b className="specification-title">Canvas Size</b>
                                <p className="specification-body">711.1x449.7x33.95mm</p>
                                <b className="specification-title">Net Weight</b>
                                <p className="specification-body">5.4Kg</p>
                                <b className="specification-title">Gross Weight</b>
                                <p className="specification-body">8.2Kg</p>
                                <b className="specification-title">Package Size</b>
                                <p className="specification-body">820x545x145mm</p>
                                <br/>
                                <i className="specification-section-title">Technical Specification</i>
                                <br/>
                                <b className="specification-title">CPU</b>
                                <p className="specification-body">UNISOC UIS8581 /8 Core Cortex A55</p>
                                <b className="specification-title">RAM</b>
                                <p className="specification-body">2GB LPDDR4</p>
                                <b className="specification-title">Storage</b>
                                <p className="specification-body">32GB eMMC</p>
                                <b className="specification-title">Control</b>
                                <p className="specification-body">Vieunite App</p>
                                <b className="specification-title">Supported Formats</b>
                                <p className="specification-body">Image (Jpg), Video (MPG, AVI, MP4)</p>
                            </Panel>
                            <Panel header="Description"
                                   className={'help-center-collapse-copy'}
                                   key="2">
                                <p>{PRODUCT_TEXT.Description}</p>
                                <p>{PRODUCT_TEXT.Description_Dimensions}</p>
                            </Panel>
                            <Panel header="Delivery" key="3" className={'help-center-collapse-copy'}>
                                <p>{PRODUCT_TEXT.Delivery}</p>
                            </Panel>
                            <Panel header="Return Policy" key="4" className={'help-center-collapse-copy'}>
                                <p>
                                    {PRODUCT_TEXT["Return Policy"]}
                                    <a href="mailto:info@vieunite.com"
                                       style={{color: "black", textDecoration: "underline"}}>
                                        support@vieunite.com.
                                    </a>
                                </p>
                            </Panel>
                            <Panel header="In the Box" key="5" className={'help-center-collapse-copy'}>
                                <p>{PRODUCT_TEXT["In the Box"]}</p>
                            </Panel>
                            <Panel header="Downloads" key="6" className={'help-center-collapse-copy'}>
                                <a href="/Vieunite - VT27WGV1 - Manual Version V4.0.pdf" target={'_blank'}>
                                    Vieunite - VT27WGV1 - Version 4.0 User Manual
                                </a>
                                <br></br>
                                <a href="/VT27WGV1 - Technical Drawing.pdf" target={'_blank'}>
                                    VT27WGV1 - Technical Drawing
                                </a>
                            </Panel>
                            <Panel header="Warranty" key="7" className={'help-center-collapse-copy'}>
                                <p>{PRODUCT_TEXT.Warranty}</p>
                            </Panel>
                        </Collapse>
                    </Col>
                </Row>

                {/*Get Support Section*/}
                <Row justify={"center"}
                     style={{
                         backgroundColor: 'black', margin: "0 8vw 5rem 8vw", borderRadius: "15px",
                     }}
                >
                    <div style={{
                        padding: "5vw", display: 'flex', flexDirection: 'column', alignItems: 'center'
                    }}>
                        <h2 className="title-app m-text"
                            style={{
                                color: 'white',
                                display: "flex",
                                justifyContent: "center", ...TitleFont,
                                margin: '0',
                            }}>
                            Get Support.
                        </h2>
                        <p className="text-content-app m-text"
                           style={{
                               color: 'white',
                               textAlign: "center",
                               paddingLeft: '5vw',
                               paddingRight: '5vw', // paddingTop: "1rem",
                               // paddingBottom: "1rem",
                               // margin: '0 1rem',
                           }}>
                            If you have questions about the Textura digital canvas or Vieunite app that
                            aren't answered here,
                            or if you encounter any issues with your product, explore our dedicated support
                            resources or reach
                            out to us for assistance.
                        </p>
                        <button
                            className="homeMainButton product-access-support-button"
                            onClick={_ => window.location.href = "/home/support"}
                            style={{width: '30vw', marginTop: '20px'}}
                        >
                            <a className={'homeMainButtonLnk homeOverV'}>
                                ACCESS SUPPORT
                            </a>
                        </button>
                    </div>
                </Row>
                <Row className={'m-img-art'} justify={'center'}
                     style={{padding: '1rem 0 1rem 0', background: '#f4f4f4'}}>
                    <Col span={10} lg={{span: 20}} xs={20}>
                        <h2 className="title-app mobile-left"
                            style={{textAlign: "left", ...TitleFont}}>
                            Additional Accessories
                        </h2>
                    </Col>
                </Row>
                <Row className={'m-img-art'} justify={'center'}
                     id={'BuyFrames'}
                     style={{
                         padding: '1rem 0 4rem 0',
                         background: '#f4f4f4',
                         columnGap: windowWidth>600?'4vw':'1vw'
                     }}>
                    <Col className={'buy-frame-col'}>
                        <img src={frame1}/>
                        <p className={'buy-frame-p1'}>
                            <span>Pine</span>
                            <span style={{marginLeft:'6.6rem'}}>£90.00</span>
                        </p>
                        <p className={'buy-frame-p2'}>
                            Additional frame in pine
                        </p>
                        <button
                            type="submit"
                            className={"pay-button"}
                            onClick={_ => {
                                // window.open('https://buy.stripe.com/eVa4gCct47iTa3u3cJ')
                                const currentValue = parseInt(localStorage.getItem('pineFrame') || '0', 10);
                                localStorage.setItem('pineFrame', (currentValue + 1).toString());
                                localStorage.setItem('openCart','1')
                                window.location.reload()
                                // Modal.success({
                                //     title: 'Success!',
                                //     content: 'An additional frame was added to cart.',
                                //     onOk: () => window.location.reload(),
                                // });
                            }}
                            style={{
                                marginTop: '0em',
                                fontFamily: "Proxima Nova Regular, sans-serif",
                                fontSize:windowWidth>920?'1rem':'.7rem',
                                fontWeight: '800',
                                borderRadius: "5px",
                                // padding: '0.5em',
                                width: '70%',
                                margin: "auto",
                                height:'3.6vh',
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center"
                            }}
                        >Add To Cart
                        </button>
                    </Col>
                    <Col className={'buy-frame-col'}>
                        <img src={frame2}/>
                        <p className={'buy-frame-p1'}>
                            <span>White</span>
                            <span style={{marginLeft:'6.6rem'}}>£90.00</span>
                        </p>
                        <p className={'buy-frame-p2'}>
                            Additional frame in white
                        </p>
                        <button
                            type="submit"
                            className={"pay-button"}
                            onClick={_ => {
                                // window.open('https://buy.stripe.com/7sI3cybp0eLl6Ri14E')
                                const currentValue = parseInt(localStorage.getItem('whiteFrame') || '0', 10);
                                localStorage.setItem('whiteFrame', (currentValue + 1).toString());
                                localStorage.setItem('openCart','1')
                                window.location.reload()
                                // Modal.success({
                                //     title: 'Success!',
                                //     content: 'An additional frame was added to cart.',
                                //     onOk: () => window.location.reload(),
                                // });
                            }}
                            style={{
                                marginTop: '0em',
                                fontFamily: "Proxima Nova Regular, sans-serif",
                                fontSize:windowWidth>920?'1rem':'.7rem',
                                fontWeight: '800',
                                borderRadius: "5px",
                                // padding: '0.5em',
                                width: '70%',
                                margin: "auto",
                                height:'3.6vh',
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center"
                            }}
                        >Add To Cart
                        </button>
                    </Col>
                    <Col className={'buy-frame-col'}>
                        <img src={frame3}/>
                        <p className={'buy-frame-p1'}>
                            <span>Walnut</span>
                            <span style={{marginLeft:'6.6rem'}}>£90.00</span>
                        </p>
                        <p className={'buy-frame-p2'}>
                            Additional frame in walnut
                        </p>
                        <button
                            type="submit"
                            className={"pay-button"}
                            onClick={_ => {
                                // window.open('https://buy.stripe.com/7sI5kG1Oq7iT6RidRp')
                                const currentValue = parseInt(localStorage.getItem('walnutFrame') || '0', 10);
                                localStorage.setItem('walnutFrame', (currentValue + 1).toString());
                                localStorage.setItem('openCart','1')
                                window.location.reload()
                                // Modal.success({
                                //     title: 'Success!',
                                //     content: 'An additional frame was added to cart.',
                                //     onOk: () => window.location.reload(),
                                // });
                            }}
                            style={{
                                marginTop: '0em',
                                fontFamily: "Proxima Nova Regular, sans-serif",
                                fontSize:windowWidth>920?'1rem':'.7rem',
                                fontWeight: '800',
                                borderRadius: "5px",
                                // padding: '0.5em',
                                width: '70%',
                                margin: "auto",
                                height:'3.6vh',
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center"
                            }}
                        >Add To Cart
                        </button>
                    </Col>
                    <Col className={'buy-frame-col'}>
                        <img src={frame4}/>
                        <p className={'buy-frame-p1'}>
                            <span>Black</span>
                            <span style={{marginLeft:'6.6rem'}}>£90.00</span>
                        </p>
                        <p className={'buy-frame-p2'}>
                            Additional frame in black
                        </p>
                        <button
                            type="submit"
                            className={"pay-button"}
                            onClick={_ => {
                                // window.open('https://buy.stripe.com/fZe7sO64Gbz97Vm3cK')
                                const currentValue = parseInt(localStorage.getItem('blackFrame') || '0', 10);
                                localStorage.setItem('blackFrame', (currentValue + 1).toString());
                                localStorage.setItem('openCart','1')
                                window.location.reload()
                                // Modal.success({
                                //     title: 'Success!',
                                //     content: 'An additional frame was added to cart.',
                                //     onOk: () => window.location.reload(),
                                // });
                            }}
                            style={{
                                marginTop: '0em',
                                fontFamily: "Proxima Nova Regular, sans-serif",
                                fontSize:windowWidth>920?'1rem':'.7rem',
                                fontWeight: '800',
                                borderRadius: "5px",
                                // padding: '0.5em',
                                width: '70%',
                                margin: "auto",
                                height:'3.6vh',
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center"
                            }}
                        >Add To Cart
                        </button>
                    </Col>
                </Row>
            </Content>
        </Layout>
    </div>)
}

export default ProductDetailsNewJack;
